/* ==========================================================================
   Casemira - Vidéos de fiche produit (C2, lot B)          25/08/2026
   --------------------------------------------------------------------------
   Un seul lecteur par page, un seul <video>, source injectée à l'ouverture et
   vidée à la fermeture. Remplace les trois scripts inline des gabarits
   handmade-carpet-decor, magic-home-2 et outdoor-2.

   ★ VAGUE 3, trois ajouts :
   1. DURÉE RÉELLE. Plus rien n'est écrit en dur dans le Liquid. Après le
      chargement complet de la page, en temps mort (`requestIdleCallback`), un
      <video preload="metadata"> temporaire lit la durée de chaque source, une
      à la fois, et l'écrit dans la carte ET dans la légende du lecteur. Le
      résultat est mémorisé par URL dans `sessionStorage`. Tant que la durée est
      inconnue, la zone reste vide : pas de faux « 20 sec ».
   2. MODE CINÉMA MOBILE. Sous 750 px (et en paysage téléphone), le lecteur est
      plein écran sur fond marine, `controls` natif retiré, contrôles maison :
      pause centrale, barre de progression, temps restant, son, plein écran,
      qui s'effacent après 2 s d'inactivité.
   3. MODE AMBIANCE. Les cartes `data-mode="ambient"` (Zoom matière) jouent en
      muet, en boucle, sans aucun contrôle : un tap sur la vidéo ferme.

   Desktop : rien ne change. `controls` natif, lecteur centré, seule la durée
   de la légende devient exacte.

   ★ VAGUE 4, quatre changements :
   1. SORTIE FACILE. Un clic ou un tap n'importe où en dehors de la vidéo et de
      ses contrôles ferme le lecteur, desktop comme mobile (le voile était en
      réalité couvert par `__frame` : son écoute ne recevait rien).
   2. BOUTON RETOUR. Sur mobile, l'ouverture empile un état `{cmVideo:true}` ;
      `popstate` ferme le lecteur au lieu de quitter la fiche, et une fermeture
      par un autre geste dépile cet état, sans double fermeture.
   3. MODE AMBIANCE. Le tap sur la vidéo ne ferme plus (il coupait la
      contemplation) : on ferme comme partout, à côté.
   4. RATIO ROBUSTE. `--cm-stage-ratio` est réappliqué à l'ouverture dès que
      `readyState >= 1`, et sur `loadeddata` en plus de `loadedmetadata`.

   ★ BULLES STORY (21/10/2026), spec SPEC-2026-10-21-BULLES-STORY.md § 5 et § 9 :
   le lecteur devient une story, à la manière d'Instagram.
   1. MODÈLE. Les bulles sont les `[data-csm-video]` de la page, dans l'ordre du
      DOM. Une bulle est une suite de diapos (`data-slides`, JSON écrit par le
      Liquid) ; une diapo est une vidéo ou une image. Un déclencheur sans
      `data-slides` (bouton « Voir le film » du bandeau de collection) vaut une
      seule diapo vidéo construite depuis ses `data-src/mode/loop/title/text`.
   2. NAVIGATION. `goTo(bulle, diapo)` remplit l'en-tête, le corps, la barre
      segmentée (un segment par diapo de la bulle ouverte), les aperçus latéraux
      et les flèches (ordinateur), puis charge la diapo. Fin d'une diapo = la
      suivante, puis la bulle suivante ; la dernière vidéo de la dernière bulle
      boucle, la dernière image reste affichée. Gestes : tiers gauche / droit de
      la scène = précédente / suivante (suivante sur la dernière = fermer), tiers
      central = contrôles, appui long = pause. Clavier : flèches, espace, Échap.
   3. IMAGES. `img.csm-video-player__img` à côté du <video>, 5 s au compteur
      (`IMAGE_MS`) qui remplit le segment ; l'image suivante est préchargée.
   4. BOUTON D'ACHAT. Recopie le texte et l'état du vrai bouton de la page, et
      le clique après la fermeture : c'est le thème qui ajoute au panier.
   5. LIBELLÉS. Plus aucun texte en dur : tout arrive par les `data-label-*` de
      `#csm-video-player`, posés traduits par le Liquid.
   Disparaissent : la légende `__caption`, « Voir aussi » `__also`, le bouton
   pause `__pp`, la barre `__bar` et le compteur `__rest`, les contrôles natifs
   sur ordinateur (`video.controls = false` partout, `cinema` vrai partout).

   ★ RETOURS DE RAPHAËL (21/10/2026, 23h34) : la barre segmentée redevient un
   curseur de lecture (glisser ou toucher le segment courant cherche dans la
   diapo, section 4 bis) et l'en-tête montre le temps restant (« -1:12 »)
   pendant la lecture d'une vidéo, la durée de la bulle en pause.

   ★ RETOUR DE RAPHAËL (22/10/2026, 18h09) : plus aucune durée affichée.
   L'en-tête, la carte qui arrive au défilement et les cartes du rail n'en
   montrent plus ; le temps restant ne vit que dans la barre basse
   (`__remain`, mode film). La sonde des métadonnées reste, pour le format
   (ratio) de chaque source seulement.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__csmVideos) return;
  window.__csmVideos = true;

  var MOBILE = '(max-width: 749px), (orientation: landscape) and (max-height: 480px) and (pointer: coarse)';
  var CTRL_HIDE = 2000; /* ms d'inactivité avant l'effacement des contrôles */
  /* ★ 22/10 (00h33) : téléphone couché = plein écran maison du mode film,
     surimpressions effacées après 3 s sans geste. Même requête que la partie
     paysage de MOBILE et que le CSS (section 3 ter). */
  var LANDSCAPE = '(orientation: landscape) and (max-height: 480px) and (pointer: coarse)';
  var CTRL_HIDE_LAND = 3000;
  /* ★ VAGUE 4 : durée de sortie, jumelle de --cm-video-dur-close (260 ms) dans
     assets/casemira-videos.css. Le panneau ne sort de l'arbre qu'après. */
  var EXIT_MS = 260;
  var DRAG_SLOP = 6; /* px au-delà desquels un geste n'est plus un tap */
  var ROT_MS = 2500; /* ms d'affichage de « Tournez votre téléphone » */
  var PROBE_TIMEOUT = 12000; /* ms avant d'abandonner la lecture des métadonnées */
  var IMAGE_MS = 5000; /* ms d'affichage d'une diapo image */
  var IMAGE_TICK = 100; /* ms entre deux mises à jour du segment d'une image */
  var HOLD_MS = 250; /* ms d'appui au-delà desquels le doigt met en pause */
  var CTA_POLL = 2000; /* ms entre deux relectures du vrai bouton d'achat */
  var KEY_ROT = 'csm-video-rotate-seen';
  var KEY_SEEN = 'csm-video-seen';
  /* ★ 22/10 (15h10) : ratio largeur / hauteur de chaque source déjà lue
     (sonde des durées, métadonnées, image chargée). La carte s'ouvre ou
     change de diapo directement au bon format, sans « saut ». */
  var KEY_RATIO = 'csm-video-ratios';
  /* Avance maximale (s) de la barre extrapolée entre deux relevés de
     `currentTime` (voir `smoothTime`). */
  var PROG_CAP = 0.35;
  var RAF = typeof window.requestAnimationFrame === 'function';
  /* ★ 22/10 (17h41) · Téléphone : défilement VERTICAL entre bulles, façon
     reels (remplace le glissement latéral et la pastille de 17h06). */
  var SWIPE_DISTANCE = 60; /* px de glissement vertical qui font basculer */
  var SWIPE_VELOCITY = 0.5; /* px/ms : un geste vif bascule plus tôt... */
  var SWIPE_MIN = 24; /* ...à partir de ce nombre de px */
  var SWIPE_RUBBER = 0.3; /* résistance vers le haut sur la dernière bulle */
  /* Indice de départ : la carte se soulève une fois, laissant voir le haut
     de la suivante. */
  var PEEK_DELAY = 1200; /* ms après l'ouverture */
  var PEEK_LIFT = 28; /* px */
  var PEEK_UP = 500; /* ms de montée... */
  var PEEK_DOWN = 450; /* ...puis de descente */
  var PEEK_EASE_UP = 'cubic-bezier(0.22, 1, 0.36, 1)'; /* --cm-video-ease */
  var PEEK_EASE_DOWN = 'cubic-bezier(0.45, 0, 0.55, 1)';
  /* Chevron « ⌃ titre court » sous le bouton d'achat : visible à l'ouverture
     pendant `UPNEXT_MS`, puis en fondu ; de retour dans les `HINT_END`
     dernières secondes de la vidéo. */
  var UPNEXT_MS = 3300;
  var HINT_END = 6; /* s */

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }
  function isLand() {
    return window.matchMedia(LANDSCAPE).matches;
  }

  /* ---- Mémoire de session : sessionStorage peut être refusé (Safari privé,
     iframe tierce). Toute lecture ou écriture est donc gardée. ------------- */
  function readStore(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key)) || {};
    } catch (e) {
      return {};
    }
  }
  function writeStore(o, key) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(o));
    } catch (e) {
      /* tant pis : on relira les métadonnées à la prochaine page */
    }
  }

  /* ========================================================================
     0 · Fonctions pures (testées sans navigateur par outils/test_js.mjs)
     ======================================================================== */

  /* Échappement pour une valeur d'attribut écrite dans du HTML. */
  function escAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* « Vidéo {{ n }} sur {{ total }} » → « Vidéo 2 sur 3 ». La clé de locale
     arrive non interpolée dans `data-label-segment` : le JS pose les nombres. */
  function labelFill(tpl, n, total) {
    if (!tpl) return '';
    return String(tpl)
      .replace(/\{\{\s*n\s*\}\}/g, String(n))
      .replace(/\{\{\s*total\s*\}\}/g, String(total));
  }

  /* Barre segmentée : un <i> par diapo, le remplissage est le <b> intérieur
     (largeur posée en ligne par le JS : 100 % passé, 0 à 100 % courant). */
  function segmentsHtml(count, tpl) {
    var h = '';
    for (var i = 0; i < count; i++) {
      h +=
        '<i class="csm-video-player__seg" role="img" data-seg="' + i + '"' +
        (tpl ? ' aria-label="' + escAttr(labelFill(tpl, i + 1, count)) + '"' : '') +
        '><b class="csm-video-player__seg-fill"></b></i>';
    }
    return h;
  }

  /* Bulle suivante pour un GESTE (tap droit, flèche, clavier) : -1 = fermer.
     La boucle de la dernière vidéo est l'affaire du gestionnaire `ended`. */
  function nextIndex(i, count) {
    return i + 1 < count ? i + 1 : -1;
  }
  function prevIndex(i) {
    return Math.max(0, i - 1);
  }

  /* Diapo suivante : dans la bulle, puis première de la bulle suivante ;
     `null` après la dernière diapo de la dernière bulle (geste = fermer). */
  function nextSlide(bubble, slide, counts) {
    if (slide + 1 < (counts[bubble] || 0)) return { bubble: bubble, slide: slide + 1 };
    if (bubble + 1 < counts.length) return { bubble: bubble + 1, slide: 0 };
    return null;
  }
  /* Diapo précédente : dans la bulle, puis dernière de la bulle précédente ;
     la première de la première reste où elle est (le lecteur la relance). */
  function prevSlide(bubble, slide, counts) {
    if (slide > 0) return { bubble: bubble, slide: slide - 1 };
    if (bubble > 0) return { bubble: bubble - 1, slide: Math.max(0, (counts[bubble - 1] || 1) - 1) };
    return { bubble: 0, slide: 0 };
  }

  /* ★ RETOURS DE RAPHAËL (21/10, 23h34) · CURSEUR DE LECTURE
     Position du doigt dans un segment, de 0 à 1 (bornée). */
  function seekRatio(x, left, width) {
    if (!(width > 0)) return 0;
    return Math.min(1, Math.max(0, (x - left) / width));
  }
  /* Segment sous le doigt d'après les bords de chaque segment ({left, right}) :
     celui qui contient x, sinon le plus proche (écart de 4 px entre deux
     segments, marges de la rangée). -1 sans segment. */
  function segAt(x, rects) {
    var best = -1;
    var dist = Infinity;
    for (var i = 0; i < rects.length; i++) {
      var r = rects[i];
      if (x >= r.left && x <= r.right) return i;
      var d = x < r.left ? r.left - x : x - r.right;
      if (d < dist) {
        dist = d;
        best = i;
      }
    }
    return best;
  }
  /* Temps restant de la barre basse : « -1:12 », « -0:07 ». Troncature : au
     départ, le restant d'une source de 100,7 s se lit « -1:40 ». Vide si la
     durée manque. */
  function remainingClock(sec) {
    if (!isFinite(sec)) return '';
    var s = Math.max(0, Math.floor(sec));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return '-' + m + ':' + (r < 10 ? '0' + r : r);
  }

  /* ★ RETOURS DE RAPHAËL (22/10, 15h10) · BARRE LISSE
     Position à peindre entre deux relevés de `currentTime` : s'il n'a pas
     bougé depuis `sinceMs` ms (certains navigateurs ne l'avancent qu'au
     rythme de `timeupdate`, 4 fois par seconde), on l'extrapole au débit de
     lecture, d'au plus `cap` secondes, sans dépasser la durée. */
  function smoothTime(read, sinceMs, rate, cap, dur) {
    if (!isFinite(read)) return 0;
    var ahead = (Math.max(0, sinceMs || 0) / 1000) * (rate > 0 ? rate : 1);
    var t = read + Math.min(cap > 0 ? cap : 0, ahead);
    return dur > 0 ? Math.min(t, dur) : t;
  }

  /* ★ 22/10 (15h10) · Barre segmentée du haut : seulement pour une story
     (2 diapos ou plus), ou pour une diapo seule qui n'a pas de barre basse
     (boucle `ambient`, image). Un film seul garde sa seule barre basse. */
  function segsVisibles(count, mode) {
    return count >= 2 || mode !== 'film';
  }

  /* ★ RETOURS DE RAPHAËL (22/10, 15h40) · GLISSER VERS LE BAS PARTOUT
     Sens d'un geste commencé sur la scène, d'après le déplacement depuis
     l'appui (dx, dy, px) : '' tant qu'il reste sous `slop` (encore un tap ou
     un appui long) ; 'fermer' si le déplacement vertical vers le bas dépasse
     `slop` et domine l'horizontal (|dy| > |dx| x 1,5) ; 'scene' sinon (geste
     horizontal ou vers le haut : rien ne se ferme, le tap est annulé). */
  function gesteVertical(dx, dy, slop) {
    var ax = Math.abs(dx);
    var ay = Math.abs(dy);
    if (!(ax > slop) && !(ay > slop)) return '';
    if (dy > slop && ay > ax * 1.5) return 'fermer';
    return 'scene';
  }

  /* ★ RETOURS DE RAPHAËL (22/10, 17h41) · DÉFILEMENT VERTICAL ENTRE BULLES
     (remplace le glissement latéral de 17h06). Tri d'un geste commencé sur
     la carte (téléphone) :
     - 'tap' tant que le déplacement reste sous `slop` (tap ou appui long) ;
     - 'vertical' : vers le haut ou vers le bas, dominant (|dy| > 1,5 |dx|) =
       bulle suivante, précédente, ou fermeture sur la première ;
     - 'aucun' sinon (horizontal, diagonale) : le tap est annulé et rien ne
       bouge, le geste peut encore devenir net. */
  var SWIPE_RATIO = 1.5;
  function gesteScene(dx, dy, slop) {
    var ax = Math.abs(dx);
    var ay = Math.abs(dy);
    if (!(ax > slop) && !(ay > slop)) return 'tap';
    if (ay > slop && ay > ax * SWIPE_RATIO) return 'vertical';
    return 'aucun';
  }
  /* Au relâché d'un glissement vertical : 'next' (vers le haut), 'prev'
     (vers le bas) ou '' (retour élastique). Bascule si le geste reste
     vertical net (|dy| > 1,5 |dx|) et dépasse `dist` px, ou s'il est vif
     (|dy| / dt > `vel` px/ms) sur `min` px au moins (un frôlement rapide
     ne change rien). */
  function swipeDecision(dx, dy, dt, dist, vel, min) {
    var ax = Math.abs(dx);
    var ay = Math.abs(dy);
    if (!(ay > 0) || !(ay > ax * SWIPE_RATIO)) return '';
    var vif = ay >= min && ay / Math.max(1, dt || 0) > vel;
    if (!(ay > dist) && !vif) return '';
    return dy < 0 ? 'next' : 'prev';
  }

  /* ★ LOT 2 (22/10) · ORIENTATION D'UN MÉDIA, d'après son ratio largeur /
     hauteur. Trois cas, lus par le CSS (`data-orient` sur le lecteur, la
     scène et l'image) :
     - 'landscape' (r > 1) : carte large sur ordinateur, fond flouté autour ;
     - 'portrait' (r < PORTRAIT_MAX, le vrai 9/16 : 0,5625) : le média remplit
       la scène en `cover`, sans fond flouté ;
     - 'upright' (PORTRAIT_MAX <= r <= 1 : 3/4, 4/5, carré) : la carte 9/16
       sur ordinateur, mais le média entier en `contain` sur le fond flouté de
       l'affiche, partout (en `cover`, un 3/4 perdrait un quart de sa largeur
       sur ordinateur, ou ses bords sur un téléphone). Décision du pilote.
     '' si le ratio est inconnu. */
  var PORTRAIT_MAX = 0.6;
  function orientOf(r) {
    if (!(r > 0)) return '';
    if (r > 1) return 'landscape';
    return r < PORTRAIT_MAX ? 'portrait' : 'upright';
  }

  /* ★ RETOUR DE RAPHAËL (22/10, 21h03) · 3/4 PLEIN CADRE AU TÉLÉPHONE
     Sur iPhone, la scène est un peu plus large que 3/4 : la vidéo « En
     situation » (810 x 1080) en `contain` laissait deux bandes fines sur les
     côtés. `cropOf(r, s)` : part de la dimension rognée quand un média de
     ratio `r` remplit en `cover` une scène de ratio `s` (0 = aucun rognage,
     0,25 = un quart de la largeur ou de la hauteur perdu). `fillOf` : vrai
     pour un média `upright` (0,6 à 1) dont le rognage reste au plus `max`
     (FILL_MAX, 20 % par défaut) ; la scène passe alors en `cover`
     (`data-fill="1"`, CSS section 2). Au-delà, `contain` sur le fond flouté,
     comme avant. Un 16/9 (`landscape`) ou un 9/16 (`portrait`, déjà en
     `cover`) ne sont jamais concernés. Téléphone debout seulement (voir
     `syncFill`) ; l'ordinateur garde sa carte 9/16. */
  var FILL_MAX = 0.2;
  function cropOf(r, s) {
    if (!(r > 0) || !(s > 0)) return 1;
    return 1 - Math.min(r, s) / Math.max(r, s);
  }
  function fillOf(r, s, max) {
    if (orientOf(r) !== 'upright') return false;
    return cropOf(r, s) <= (max > 0 ? max : FILL_MAX) + 1e-9;
  }

  /* ★ RETOURS DU 22/10 (23h21) · CARTE D'ORDINATEUR SANS BANDES, ET JAMAIS
     VIDE.
     1. Ratio posé en variable : un nombre fini et positif, sinon '' (la
        variable est retirée et le CSS reprend son repli 16/9 ; la carte est
        alors la carte 9/16 d'avant). Une vidéo sans métadonnées
        (`videoWidth` 0) ne peut donc jamais donner un ratio de 0.
     2. Diapo `upright` (3/4 à carré) sur ordinateur : la scène prend le ratio
        du média, à hauteur de carte inchangée. Largeur de la carte =
        (hauteur de la carte moins le reste : segments, en-tête, corps,
        bouton) x ratio, bornée entre 40 % de la hauteur (plancher : jamais
        une carte vide) et la hauteur (carré). Ratio inconnu : la carte 9/16.
        Le CSS fait le même calcul (section 2 ter, bloc « 23h21 ») ; cette
        fonction sert de référence aux tests.
     3. Le « reste » (`--csm-chrome` pour la carte large, `--csm-pchrome`
        pour la carte debout) se mesure : hauteur de la carte moins celle de
        la scène. Mesuré PENDANT la transition de largeur, sur une carte
        encore étroite, le corps passait sur vingt lignes, la scène tombait à
        0 et la mesure valait la carte entière : la carte large visée
        rétrécissait, la mesure suivante grandissait encore, jusqu'à une
        largeur de 1 px (la barre noire vue par Baptiste, reproduite dans
        Chromium à 1 400 x 716). `chromeOf` refuse une scène écrasée (0) et
        plafonne la mesure (`chromeCap`) ; `sizingWait` fait attendre la fin
        de la transition, avec un secours si elle ne finit jamais. */
  function ratioVar(r) {
    return r > 0 && isFinite(r) ? r.toFixed(4) : '';
  }
  function uprightWidth(cardH, chrome, r) {
    if (!(cardH > 0)) return 0;
    if (!(r > 0) || !isFinite(r)) return (cardH * 9) / 16;
    var c = chrome > 0 ? chrome : 0;
    return Math.min(Math.max((cardH - c) * r, cardH * 0.4), cardH);
  }
  function chromeOf(boxH, stageH, cap) {
    if (!(boxH > 0) || !(stageH > 1)) return 0;
    var c = boxH - stageH;
    if (!(c > 0)) return 0;
    return cap > 0 ? Math.min(c, cap) : c;
  }
  /* Plafond du reste : 40 % de la fenêtre (200 px au moins) pour la carte
     large, la moitié de la carte (240 px au moins) pour la carte debout. */
  function chromeCap(vh, o) {
    if (!(vh > 0)) return 0;
    if (o === 'upright') return Math.round(Math.max(240, Math.min(vh * 0.86, 760) * 0.5));
    return Math.round(Math.max(200, vh * 0.4));
  }
  /* Attente avant de mesurer : jusqu'à la fin prévue de la transition
     (`until`), plus tant qu'une transition de taille tourne encore
     (`running`), mais pas au-delà de `SIZING_GRACE` après la fin prévue :
     passé ce délai, on mesure quand même (fin de transition de secours, si
     `transitionend` n'arrive jamais). */
  var SIZING_GRACE = 900;
  function sizingWait(until, nowMs, running) {
    var left = until - nowMs;
    if (running && left > -SIZING_GRACE) return Math.max(left, 60);
    return left > 0 ? left : 0;
  }

  /* Tiers de la scène sous le doigt. */
  function tapZone(x, width) {
    if (x < width / 3) return 'prev';
    if (x > (width * 2) / 3) return 'next';
    return 'center';
  }

  /* État du bouton de la story d'après le vrai bouton d'achat de la page :
     texte recopié (langue, prix, variante : rien n'est réécrit), `disabled`
     recopié (rupture, précommande), masqué s'il n'y a pas de bouton. */
  function ctaState(btn) {
    if (!btn) return { text: '', disabled: true, hidden: true };
    /* Le thème sépare « Ajouter au panier », « · » et le prix par des <span>
       espacés en CSS : le texte brut les colle (« panier·749,00 € »). Seuls
       les espaces autour du point médian sont rétablis, aucun mot ne change. */
    var text = String(btn.textContent || '')
      .replace(/\s*\u00b7\s*/g, ' \u00b7 ')
      .replace(/\s+/g, ' ')
      .replace(/^ | $/g, '');
    var aria = btn.getAttribute ? btn.getAttribute('aria-disabled') : null;
    return { text: text, disabled: !!btn.disabled || aria === 'true', hidden: !text };
  }

  /* Entités HTML restées dans un `data-*` échappé deux fois : le bandeau de
     collection (`casemira-collection-hero.liquid`, hors chantier) écrit
     `l&amp;#39;atelier`, que le navigateur rend `l&#39;atelier` et que
     `textContent` affichait tel quel. Le texte va toujours en `textContent` :
     décoder ces cinq formes ne peut rien injecter. */
  function decodeEntities(s) {
    return String(s || '')
      .replace(/&#0*39;|&#x0*27;|&apos;/gi, "'")
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }

  /* Une diapo propre, quel que soit ce que le JSON porte. */
  function slideOf(o) {
    if (!o || !o.src) return null;
    var image = o.type === 'image';
    return {
      type: image ? 'image' : 'video',
      src: String(o.src),
      poster: String(o.poster || (image ? o.src : '')),
      mode: image ? '' : o.mode === 'ambient' ? 'ambient' : 'film',
      loop: o.loop === true || o.loop === '1',
      title: String(o.title || ''),
      text: String(o.text || '')
    };
  }

  /* Diapos d'une bulle : le JSON de `data-slides`, sinon (bandeau de
     collection, JSON illisible ou vide) une diapo vidéo tirée des `data-*`. */
  function parseSlides(card) {
    var d = (card && card.dataset) || {};
    var out = [];
    if (d.slides) {
      var list = null;
      try {
        list = JSON.parse(d.slides);
      } catch (e) {
        list = null;
      }
      if (list && list.length) {
        for (var i = 0; i < list.length; i++) {
          var s = slideOf(list[i]);
          if (s) out.push(s);
        }
      }
    }
    if (out.length) return out;
    var one = slideOf({
      type: 'video',
      src: d.src,
      poster: d.poster,
      mode: d.mode,
      loop: d.loop,
      title: decodeEntities(d.title),
      text: decodeEntities(d.text)
    });
    return one ? [one] : [];
  }

  /* ★ FINITION (21/10) · Valeur CSS `url("…")` pour le fond d'ambiance de la
     scène (`--csm-stage-poster`). Les guillemets et les barres obliques
     inverses de l'URL sont encodés : la valeur ne peut pas sortir de `url()`.
     URL vide : chaîne vide (l'appelant retire alors la propriété). */
  function cssUrl(url) {
    if (!url) return '';
    return 'url("' + String(url).replace(/["\\\n\r]/g, encodeURIComponent) + '")';
  }

  if (window.__csmVideosTest === true) {
    window.__csmVideosApi = {
      cssUrl: cssUrl,
      segmentsHtml: segmentsHtml,
      nextIndex: nextIndex,
      prevIndex: prevIndex,
      nextSlide: nextSlide,
      prevSlide: prevSlide,
      parseSlides: parseSlides,
      ctaState: ctaState,
      tapZone: tapZone,
      seekRatio: seekRatio,
      segAt: segAt,
      remainingClock: remainingClock,
      smoothTime: smoothTime,
      segsVisibles: segsVisibles,
      gesteVertical: gesteVertical,
      gesteScene: gesteScene,
      swipeDecision: swipeDecision,
      orientOf: orientOf,
      cropOf: cropOf,
      fillOf: fillOf,
      FILL_MAX: FILL_MAX,
      ratioVar: ratioVar,
      uprightWidth: uprightWidth,
      chromeOf: chromeOf,
      chromeCap: chromeCap,
      sizingWait: sizingWait,
      SIZING_GRACE: SIZING_GRACE,
      labelFill: labelFill,
      IMAGE_MS: IMAGE_MS,
      cdnWidth: cdnWidth,
      imageSrcset: imageSrcset
    };
  }

  /* Les affiches et images du CDN Shopify sans largeur sont servies à leur
     taille d'origine (plusieurs centaines de Ko) : on demande la largeur utile.
     Une URL qui porte déjà `width=`, ou qui n'est pas du CDN, reste telle quelle. */
  /* ★ 23/10 (Stories Rezas) : une URL du CDN Shopify qui porte déjà `width=`
     (les images des stories arrivent du Liquid à 1 600 px, les affiches à
     800) reçoit la largeur demandée à la place : la mini bulle de l'en-tête
     ne télécharge plus une image de 800 px pour 34 px affichés. Hors CDN :
     l'URL telle quelle, comme avant. */
  function cdnWidth(url, w) {
    if (!url) return '';
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ★ 23/10 (Stories Rezas) · `srcset` des diapos image : trois largeurs du
     CDN (720, 1 080, 1 600) ; `sizes` = la largeur de l'écran au téléphone,
     75 % de la hauteur de fenêtre sur ordinateur (carte 3/4 ou plein écran).
     Chaîne vide hors CDN Shopify (l'image garde son seul `src`). */
  var IMAGE_SIZES = '(max-width: 749px) 100vw, 75vh';
  function imageSrcset(url) {
    if (!url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return '';
    return [720, 1080, 1600]
      .map(function (w) {
        return cdnWidth(url, w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  ready(function () {
    var wrap = document.querySelector('.csm-videos');
    var player = document.getElementById('csm-video-player');
    if (!player) return;

    /* ★ VAGUE 10 C3 · LES DÉCLENCHEURS SONT CHERCHÉS DANS TOUT LE DOCUMENT.
       Jusqu'ici ils devaient être des `.csm-video-card` DANS `.csm-videos` :
       le lecteur ne savait ouvrir que les vignettes de la liste qui le
       précède. Depuis la vague 10, le bandeau de collection porte un bouton
       « Voir le film » qui n'est pas une vignette et ne vit pas dans cette
       liste (`snippets/casemira-collection-hero.liquid`).

       Le sélecteur devient donc `[data-csm-video]`, l'attribut que les
       vignettes portaient DÉJÀ : rien à ajouter à la fiche produit, et le
       lecteur reste ce qu'il est - un singleton de page qui ouvre ce qu'on lui
       donne. La liste, elle, devient facultative (`lecteur_seul`).
       ★ BULLES STORY : ces déclencheurs sont les bulles de la story, dans
       l'ordre du DOM ; un déclencheur sans aucune diapo lisible est ignoré. */
    var bubbles = [];
    var slidesOf = [];
    [].slice.call(document.querySelectorAll('[data-csm-video]')).forEach(function (card) {
      var s = parseSlides(card);
      if (!s.length) return;
      bubbles.push(card);
      slidesOf.push(s);
    });
    if (!bubbles.length) return;
    var counts = slidesOf.map(function (s) {
      return s.length;
    });
    /* Ratios connus (session) : voir KEY_RATIO. */
    var ratios = readStore(KEY_RATIO);
    function rememberRatio(src, r) {
      if (!src || !(r > 0) || !isFinite(r)) return;
      r = Math.round(r * 10000) / 10000;
      if (ratios[src] === r) return;
      ratios[src] = r;
      writeStore(ratios, KEY_RATIO);
    }

    function q(sel) {
      return player.querySelector(sel);
    }
    /* ★ 22/10 (16h04) : les variables de taille de la carte (`--cm-stage-ratio`,
       `--csm-chrome`) vivent sur la carte ET sur le cadre, où le CSS cale les
       voisines et les flèches de la carte large (section 2 ter). Valeur vide :
       retirée des deux. */
    function stageVar(name, v) {
      /* ★ 23h21 : toute variable de taille qui change relance la transition
         de la carte ; la mesure du reste attend sa fin (`markSizing`). */
      if (box && (box.style.getPropertyValue(name) || '') !== (v || '')) markSizing();
      [box, frame].forEach(function (el) {
        if (!el) return;
        if (v) el.style.setProperty(name, v);
        else el.style.removeProperty(name);
      });
    }
    var video = q('.csm-video-player__video');
    var box = q('.csm-video-player__box');
    var stage = q('.csm-video-player__stage');
    var frame = q('.csm-video-player__frame');
    var elSegs = q('[data-csm-video-segs]');
    var elHeadImg = q('.csm-video-player__head-img');
    var elHeadTitle = q('.csm-video-player__head-title');
    var elTitle = q('.csm-video-player__title');
    var elText = q('.csm-video-player__text');
    var sideBefore = q('.csm-video-player__side--before');
    var sideAfter = q('.csm-video-player__side--after');
    var prevBtn = q('[data-csm-video-prev]');
    var nextBtn = q('[data-csm-video-next]');
    var ctaBtn = q('[data-csm-video-cta]');
    var soundBtn = q('[data-csm-video-sound]');
    var playBtn = q('[data-csm-video-play]');
    var fullBtn = q('[data-csm-video-full]');
    var rot = q('.csm-video-player__rot');
    var img = null; /* <img> des diapos image, créé à la première */

    /* ★ BARRE DE LECTURE BASSE (22/10, retour de Raphaël de 00h33 après essai
       sur iPhone : la barre segmentée du haut n'est ni vue ni atteignable
       sous la barre d'outils de Safari). En mode film, la rangée des
       contrôles, en bas de la scène, devient celle de l'ancien lecteur
       cinéma : son, barre de progression glissable, temps restant, plein
       écran. Construite ici (aucun texte : le nom accessible est celui des
       segments, `casemira.a11y.position_video`, posé par le Liquid) et
       montrée par le CSS en mode film seulement. */
    var ctrlBox = q('.csm-video-player__ctrl');
    var seek = null;
    var seekTrack = null;
    var seekFill = null;
    var seekKnob = null;
    var elRemain = null;
    if (ctrlBox) {
      seek = document.createElement('div');
      seek.className = 'csm-video-player__seek';
      seek.setAttribute('role', 'group');
      if (elSegs && elSegs.getAttribute('aria-label')) seek.setAttribute('aria-label', elSegs.getAttribute('aria-label'));
      seek.innerHTML =
        '<span class="csm-video-player__seek-track"><b class="csm-video-player__seek-fill"></b>' +
        '<i class="csm-video-player__seek-knob"></i></span>';
      seekTrack = seek.firstChild;
      seekFill = seekTrack.firstChild;
      seekKnob = seekTrack.lastChild;
      elRemain = document.createElement('span');
      elRemain.className = 'csm-video-player__remain';
      /* ★ 22/10 (15h40) : pause / lecture, barre, temps restant, puis son et
         plein écran à droite. La barre se glisse donc devant le son. */
      var ctrlRef = soundBtn && soundBtn.parentNode === ctrlBox ? soundBtn : fullBtn && fullBtn.parentNode === ctrlBox ? fullBtn : null;
      ctrlBox.insertBefore(seek, ctrlRef);
      ctrlBox.insertBefore(elRemain, ctrlRef);
    }

    function label(name) {
      return player.getAttribute('data-label-' + name) || '';
    }

    /* Affiche et titre court d'une bulle, tels que le rail les montre : la
       carte (`data-poster`, choisie par le Liquid ; les vidéos habillées ont
       un aperçu Shopify uni, inutilisable) puis sa première diapo. */
    function posterOf(b) {
      return bubbles[b].dataset.poster || slidesOf[b][0].poster;
    }
    function shortOf(b) {
      var d = bubbles[b].dataset;
      return decodeEntities(d.short || d.title) || slidesOf[b][0].title;
    }

    /* ★ RETOURS DE RAPHAËL (22/10, 17h41) · CHEVRON DE LA BULLE SUIVANTE
       (remplace la pastille de 17h06). Téléphone (le CSS le masque ailleurs) :
       centré dans la marge basse de la carte, sous le bouton d'achat, un
       petit chevron vers le haut et le titre court de la bulle suivante, en
       blanc à 70 %. Visible à l'ouverture pendant `UPNEXT_MS` puis en fondu,
       de retour dans les 6 dernières secondes de la dernière vidéo de la
       bulle (`data-upnext` sur le lecteur) ; `hidden` sur la dernière bulle.
       Le tap mène à la bulle suivante, comme un glissement vers le haut. Nom
       accessible : `data-label-next` et le titre. Construit ici : aucun texte
       en dur. */
    var upnext = null;
    var upnextTitle = null;
    var upnextFor = -1;
    var upnextTimer = 0;
    if (box) {
      upnext = document.createElement('button');
      upnext.type = 'button';
      upnext.className = 'csm-video-player__upnext';
      upnext.hidden = true;
      upnext.innerHTML =
        '<svg class="csm-video-player__upnext-ico" viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
        '<path d="M6.5 14.5 12 9l5.5 5.5"/></svg>' +
        '<span class="csm-video-player__upnext-title"></span>';
      upnextTitle = upnext.lastChild;
      box.appendChild(upnext);
    }

    /* ★ 22/10 (17h41) · CARTES VOISINES DU DÉFILEMENT VERTICAL (téléphone) :
       deux panneaux de la taille de la carte, sous elle (suivante) et
       au-dessus (précédente), cachés hors geste et hors indice de départ.
       Chacun rend la carte de sa bulle comme elle arrivera : en-tête (mini
       bulle, titre court ; plus de durée depuis le 22/10 18h09), scène avec l'affiche de la carte du rail
       (`data-poster`) en `cover` sur le noir de salle, corps et copie du
       bouton d'achat. Décor (`aria-hidden`) : le chevron et le clavier
       portent la navigation. */
    var swipeNext = null;
    var swipePrev = null;
    function makePanel(side) {
      var el = document.createElement('div');
      el.className = 'csm-video-player__swipe csm-video-player__swipe--' + side + ' no-empty';
      el.setAttribute('aria-hidden', 'true');
      el.hidden = true;
      frame.appendChild(el);
      return el;
    }
    if (frame && box) {
      swipeNext = makePanel('next');
      swipePrev = makePanel('prev');
    }

    var isOpen = false;
    var opener = null;
    var current = null; /* carte de la bulle ouverte */
    var pos = { bubble: -1, slide: -1 };
    var kind = 'video'; /* type de la diapo courante */
    var mode = 'film';
    var mobileOpen = false; /* requête MOBILE vraie à l'ouverture */
    var segBubble = -1; /* bulle pour laquelle la barre segmentée est construite */
    var sideBubble = -1; /* bulle pour laquelle les aperçus sont construits */
    var closeToken = 0;
    var hideTimer = 0;
    var rotTimer = 0;
    var rotActive = false;
    var ctaTimer = 0;

    /* Le lecteur doit échapper aux ancêtres transformés (Swiper de la galerie) :
       sinon `position: fixed` se cale sur la colonne produit et le haut de la
       modale passe derrière l'en-tête. Report du correctif de l'ancien bloc. */
    if (player.parentNode !== document.body) document.body.appendChild(player);

    /* Ordinateur comme mobile : mêmes contrôles maison (spec § 5.3). */
    player.dataset.cinema = '1';
    video.controls = false;

    /* ---- Verrou de défilement : overflow sur <html>, jamais fixed sur body -- */
    function lockScroll() {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--csm-video-sbw', sbw + 'px');
      document.documentElement.classList.add('csm-video-locked');
    }
    function unlockScroll() {
      document.documentElement.classList.remove('csm-video-locked');
      document.documentElement.style.removeProperty('--csm-video-sbw');
    }

    /* ======================================================================
       1 · Format des sources (sonde des métadonnées)
       ★ 22/10 (18h09) : la durée n'est plus affichée nulle part (retour de
       Raphaël) ; `applyDuration`, `bubbleSeconds` et `formatDuration` sont
       retirés. La sonde ne sert plus qu'au ratio de chaque source vidéo
       (KEY_RATIO), pour ouvrir la carte directement au bon format.
       ====================================================================== */
    /* Un <video> hors document, `preload="metadata"` : aucun octet d'image, la
       seule entête du fichier. Détruit dès les métadonnées lues. */
    function probe(src, done) {
      var v = document.createElement('video');
      var settled = false;
      var timer = 0;

      function end(sec, ratio) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        try {
          v.removeAttribute('src');
          v.load();
        } catch (e) {
          /* rien à récupérer */
        }
        done(sec, ratio || 0);
      }

      v.preload = 'metadata';
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.addEventListener('loadedmetadata', function () {
        end(isFinite(v.duration) ? v.duration : 0, v.videoWidth && v.videoHeight ? v.videoWidth / v.videoHeight : 0);
      });
      v.addEventListener('error', function () {
        end(0);
      });
      timer = window.setTimeout(function () {
        end(0);
      }, PROBE_TIMEOUT);
      v.src = src;
    }

    function fillRatios() {
      var queue = [];
      slidesOf.forEach(function (slides) {
        slides.forEach(function (s) {
          if (s.type !== 'video' || ratios[s.src]) return;
          if (queue.indexOf(s.src) === -1) queue.push(s.src);
        });
      });

      /* Une source à la fois : deux téléchargements d'entête en parallèle sur
         un réseau mobile, c'est déjà de la concurrence pour la fiche. */
      (function next() {
        var src = queue.shift();
        if (!src) return;
        probe(src, function (sec, ratio) {
          rememberRatio(src, ratio);
          next();
        });
      })();
    }

    /* Après le chargement complet de la page, et seulement en temps mort : le
       format est un confort d'ouverture, il ne doit rien coûter au LCP. */
    function scheduleRatios() {
      var run = function () {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(fillRatios, { timeout: 3000 });
        } else {
          window.setTimeout(fillRatios, 1200);
        }
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }
    scheduleRatios();

    /* ---- Bulles déjà vues dans la session : `.is-seen` (anneau éteint) ---- */
    function markSeen(b) {
      var card = bubbles[b];
      if (!card) return;
      card.classList.add('is-seen');
      var seen = readStore(KEY_SEEN);
      var key = slidesOf[b][0].src;
      if (seen[key]) return;
      seen[key] = 1;
      writeStore(seen, KEY_SEEN);
    }
    (function replaySeen() {
      var seen = readStore(KEY_SEEN);
      bubbles.forEach(function (card, b) {
        if (seen[slidesOf[b][0].src]) card.classList.add('is-seen');
      });
    })();

    /* ======================================================================
       2 · Contenu du lecteur : en-tête, corps, segments, aperçus
       ====================================================================== */
    function fillHead(b) {
      var card = bubbles[b];
      var d = card.dataset;
      var poster = d.poster || slidesOf[b][0].poster;
      if (elHeadImg) {
        if (poster) {
          elHeadImg.src = cdnWidth(poster, 120);
          elHeadImg.hidden = false;
        } else {
          elHeadImg.removeAttribute('src');
          elHeadImg.hidden = true;
        }
      }
      /* Montré par le CSS sur le téléphone couché et en plein écran
         seulement (retour de Raphaël, 22/10 18h09). */
      if (elHeadTitle) elHeadTitle.textContent = decodeEntities(d.short || d.title) || slidesOf[b][0].title;
    }

    function segEls() {
      return elSegs ? elSegs.children : [];
    }
    function setSegFill(i, ratio) {
      var seg = segEls()[i];
      var fill = seg && seg.firstChild;
      var w = (Math.min(1, Math.max(0, ratio)) * 100).toFixed(2) + '%';
      if (fill) fill.style.width = w;
      /* La barre basse suit le segment courant. */
      if (i === pos.slide && seekFill) {
        seekFill.style.width = w;
        seekKnob.style.left = w;
      }
    }
    /* Segments précédents pleins, courant vide (il se remplit), suivants vides. */
    function markSegments(s) {
      var list = segEls();
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('is-done', i < s);
        list[i].classList.toggle('is-current', i === s);
        if (i === s) list[i].setAttribute('aria-current', 'true');
        else list[i].removeAttribute('aria-current');
        setSegFill(i, i < s ? 1 : 0);
      }
    }
    function buildSegments(b) {
      if (!elSegs) return;
      if (segBubble === b && segEls().length === counts[b]) return;
      elSegs.innerHTML = segmentsHtml(counts[b], label('segment'));
      segBubble = b;
    }

    /* Aperçu d'une bulle voisine (ordinateur) : l'affiche, une mini bulle et le
       titre court. Les aperçus sont `aria-hidden` (décor) : le bouton sort de
       l'ordre de tabulation, les flèches portent la navigation au clavier. */
    function peek(b) {
      var card = bubbles[b];
      var d = card.dataset;
      var poster = d.poster || slidesOf[b][0].poster;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'csm-video-player__peek';
      btn.tabIndex = -1;
      btn.setAttribute('data-bubble', String(b));
      if (poster) {
        var bg = document.createElement('img');
        bg.className = 'csm-video-player__peek-img';
        bg.alt = '';
        bg.decoding = 'async';
        bg.addEventListener('load', function () {
          if (bg.naturalWidth && bg.naturalHeight) {
            posterRatio[b] = bg.naturalWidth / bg.naturalHeight;
            syncSideRatios();
          }
        });
        bg.src = cdnWidth(poster, 480);
        btn.appendChild(bg);
      }
      var foot = document.createElement('span');
      foot.className = 'csm-video-player__peek-foot';
      var ring = document.createElement('span');
      ring.className = 'csm-video-player__peek-ring';
      if (poster) {
        var mini = document.createElement('img');
        mini.className = 'csm-video-player__peek-bubble';
        mini.alt = '';
        mini.decoding = 'async';
        mini.src = cdnWidth(poster, 120);
        ring.appendChild(mini);
      }
      var t = document.createElement('span');
      t.className = 'csm-video-player__peek-title';
      t.textContent = decodeEntities(d.short || d.title) || slidesOf[b][0].title;
      foot.appendChild(ring);
      foot.appendChild(t);
      btn.appendChild(foot);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(b, 0);
      });
      return btn;
    }
    function fillSide(side, b) {
      if (!side) return;
      side.innerHTML = '';
      side.setAttribute('data-bubble', String(b));
      if (b >= 0) side.appendChild(peek(b));
    }
    /* ★ 22/10 (16h04) · Ratio de la voisine (carte large) : celui de sa propre
       affiche, ramené à 9/16 (portrait) ou 16/9 (paysage). Lu sur l'image
       une fois chargée ; en attendant, le ratio connu de sa première diapo
       (KEY_RATIO), sinon 16/9. Posé sur le cadre (`--csm-nb-ra` à droite,
       `--csm-nb-rb` à gauche), où le CSS dessine la voisine et sa flèche. */
    var posterRatio = {};
    function nbRatio(b) {
      var r = posterRatio[b];
      if (!(r > 0) && slidesOf[b]) r = ratios[slidesOf[b][0].src];
      return r > 0 && r < 1 ? '0.5625' : '1.7778';
    }
    function syncSideRatios() {
      if (!frame) return;
      [
        [sideAfter, '--csm-nb-ra'],
        [sideBefore, '--csm-nb-rb']
      ].forEach(function (p) {
        var b = p[0] ? parseInt(p[0].getAttribute('data-bubble'), 10) : -1;
        if (b >= 0) frame.style.setProperty(p[1], nbRatio(b));
        else frame.style.removeProperty(p[1]);
      });
    }
    function buildSides(b) {
      if (sideBubble === b) return;
      sideBubble = b;
      var solo = bubbles.length < 2;
      var before = b > 0 ? b - 1 : -1;
      var after = nextIndex(b, bubbles.length);
      fillSide(sideBefore, solo ? -1 : before);
      fillSide(sideAfter, solo ? -1 : after);
      if (sideBefore) sideBefore.hidden = solo;
      if (sideAfter) sideAfter.hidden = solo;
      syncSideRatios();
      if (prevBtn) prevBtn.hidden = solo || before < 0;
      if (nextBtn) nextBtn.hidden = solo || after < 0;
    }

    /* ★ 22/10 (17h41) · Chevron : rempli pour la bulle suivante, montré à
       l'ouverture (`atOpen`) pendant `UPNEXT_MS`, puis dans la fin de la
       vidéo (`upnextEnd`) ; `hidden` sur la dernière bulle. */
    function resetUpnext(b, atOpen) {
      window.clearTimeout(upnextTimer);
      player.removeAttribute('data-upnext');
      if (!upnext) return;
      var n = nextIndex(b, bubbles.length);
      if (n < 0) {
        upnext.hidden = true;
        upnextFor = -1;
        return;
      }
      if (upnextFor !== n) {
        upnextFor = n;
        var t = shortOf(n);
        upnextTitle.textContent = t;
        var lab = label('next');
        upnext.setAttribute('aria-label', lab && t ? lab + ', ' + t : lab || t);
      }
      upnext.hidden = false;
      if (!atOpen) return;
      player.setAttribute('data-upnext', 'on');
      upnextTimer = window.setTimeout(function () {
        if (player.getAttribute('data-upnext') === 'on') player.removeAttribute('data-upnext');
      }, UPNEXT_MS);
    }
    /* Dernière vidéo de la bulle, 6 dernières secondes : le chevron revient,
       même couché quand les surimpressions sont effacées (CSS). */
    function upnextEnd() {
      if (!isOpen || !upnext || upnext.hidden || kind !== 'video' || pos.slide !== counts[pos.bubble] - 1) return;
      if (player.getAttribute('data-upnext') === 'end') return;
      var d = video.duration;
      if (isFinite(d) && d > 0 && d - video.currentTime <= HINT_END) {
        window.clearTimeout(upnextTimer);
        player.setAttribute('data-upnext', 'end');
      }
    }

    /* ★ 22/10 (17h41) · Carte voisine du défilement : rendue comme la carte
       qui arrivera (en-tête, affiche en `cover` à la place de la scène,
       corps, copie du bouton d'achat). Remplie à l'arrivée sur une bulle
       (téléphone seulement), pour que l'affiche soit chargée avant le geste ;
       bouton relu à chaque geste (`syncPanel`). ★ 22/10 (18h09) : en-tête =
       mini bulle et titre court, sans durée. */
    function mk(tag, cls, parent) {
      var x = document.createElement(tag);
      x.className = 'csm-video-player__' + cls;
      if (parent) parent.appendChild(x);
      return x;
    }
    function fillPanel(p, b) {
      if (!p) return;
      var key = String(b);
      if (p.getAttribute('data-bubble') !== key) {
        p.setAttribute('data-bubble', key);
        p.innerHTML = '';
        if (b < 0) return;
        var card = bubbles[b];
        var first = slidesOf[b][0];
        var poster = posterOf(b);
        var head = mk('div', 'swipe-head', p);
        var ring = mk('span', 'swipe-ring', head);
        if (poster) {
          var mini = mk('img', 'swipe-mini', ring);
          mini.alt = '';
          mini.decoding = 'async';
          mini.src = cdnWidth(poster, 120);
        }
        mk('span', 'swipe-title', head).textContent = shortOf(b);
        var scene = mk('div', 'swipe-scene', p);
        if (poster) {
          var bg = mk('img', 'swipe-img', scene);
          bg.alt = '';
          bg.decoding = 'async';
          bg.src = cdnWidth(poster, 900);
        }
        var body = mk('div', 'swipe-body', p);
        mk('p', 'swipe-name', body).textContent = first.title || decodeEntities(card.dataset.title);
        mk('p', 'swipe-text', body).textContent = first.text || decodeEntities(card.dataset.text);
        mk('span', 'swipe-cta', p);
      }
      syncPanel(p, b);
    }
    /* Texte du bouton d'achat (recopié du vrai, absent s'il l'est). */
    function syncPanel(p, b) {
      if (!p || b < 0 || !p.firstChild) return;
      var cta = p.querySelector('.csm-video-player__swipe-cta');
      if (!cta) return;
      var show = !!ctaBtn && !ctaBtn.hidden && !!ctaBtn.textContent;
      cta.hidden = !show;
      cta.textContent = show ? ctaBtn.textContent : '';
    }
    function fillPanels(b) {
      if (!swipeNext || !isMobile()) return;
      fillPanel(swipeNext, nextIndex(b, bubbles.length));
      fillPanel(swipePrev, b - 1);
    }
    /* Le haut de l'en-tête de la vraie carte (segments, encoche) : la voisine
       pose le sien au même endroit, l'arrivée ne saute pas. */
    function measurePanels() {
      var h = q('.csm-video-player__head');
      if (!h || !swipeNext) return;
      var top = Math.max(0, Math.round(h.getBoundingClientRect().top - box.getBoundingClientRect().top));
      [swipeNext, swipePrev].forEach(function (p) {
        if (p) p.style.setProperty('--csm-sw-top', top + 'px');
      });
    }

    /* ======================================================================
       3 · Diapos : vidéo, image, enchaînement
       ====================================================================== */

    /* Le cadre épouse le ratio réel de la source (desktop : plus de bandes
       latérales sur une vidéo carrée ou verticale ; mobile : la scène se pose
       bord à bord au vrai ratio).

       ★ VAGUE 4 · POURQUOI RAPH VOYAIT ENCORE DES BANDES ET PAS PLAYWRIGHT
       Le ratio n'était appliqué qu'à `loadedmetadata`. Or, sur desktop, le
       survol de la carte charge déjà la source en `preload="metadata"` : à
       l'instant du clic, le <video> porte DÉJÀ la même `src` et ses
       métadonnées (`readyState >= 1`). `open()` retirait alors
       `--cm-stage-ratio`, et `load()`, qui ne réattache la source que si elle
       change, n'en changeait pas : AUCUN nouvel événement n'était émis, et le
       cadre restait sur son 16/9 par défaut. Sur une source 638 x 480 (Zoom
       matière, ratio 1,33) cela donne exactement les bandes latérales décrites.
       Playwright ne le voyait pas : son clic suit le survol de si près que les
       métadonnées arrivent APRÈS l'ouverture, et l'événement corrigeait tout,
       d'où le cadre 877 x 660 mesuré par c2-ratio.mjs.

       Trois filets désormais : `loadedmetadata`, `loadeddata` (au cas où les
       métadonnées seraient déjà en cache au moment de l'écoute), et une
       application immédiate à l'ouverture dès que `readyState >= 1`. */
    function applyRatio() {
      if (kind !== 'video') return;
      if (video.videoWidth && video.videoHeight) {
        stageVar('--cm-stage-ratio', ratioVar(video.videoWidth / video.videoHeight));
        setOrient(video.videoWidth / video.videoHeight);
        rememberRatio(video.getAttribute('src'), video.videoWidth / video.videoHeight);
      }
    }
    video.addEventListener('loadedmetadata', applyRatio);
    video.addEventListener('loadeddata', applyRatio);
    /* Safari iOS : videoWidth/videoHeight peuvent encore valoir 0 a
       loadedmetadata et n'etre connus qu'a `resize` (evenement emis quand les
       dimensions intrinseques changent), `canplay` ou `playing`. Sans cela la
       scene restait en 16/9 et une video 4/3 s'affichait en petit, cernee de
       noir (constate par Raph sur iPhone le 25/08). */
    video.addEventListener('resize', applyRatio);
    video.addEventListener('canplay', applyRatio);
    video.addEventListener('playing', applyRatio);
    video.addEventListener('timeupdate', applyRatio, { once: true });

    /* Image : même variable de ratio, et `data-orient` pour le CSS (`cover` en
       portrait, `contain` en paysage, spec § 9 ; ★ lot 2 : `contain` aussi
       entre 0,6 et 1, voir `orientOf`). */
    function applyImageRatio() {
      if (kind !== 'image' || !img || !img.naturalWidth || !img.naturalHeight) return;
      var r = img.naturalWidth / img.naturalHeight;
      img.setAttribute('data-orient', orientOf(r));
      stageVar('--cm-stage-ratio', ratioVar(r));
      setOrient(r);
      var s = slidesOf[pos.bubble] && slidesOf[pos.bubble][pos.slide];
      if (s && s.type === 'image') rememberRatio(s.src, r);
    }

    /* ★ 22/10 (15h10) · Ratio déjà connu de la diapo (KEY_RATIO) : posé
       AVANT le chargement, donc avant la première peinture à l'ouverture.
       Sur ordinateur la carte prend tout de suite sa forme (9/16 ou large),
       sans sauter à `loadedmetadata`. Faux si le ratio est inconnu. */
    function presetRatio(slide) {
      var r = ratios[slide.src];
      if (!(r > 0) || !isFinite(r)) return false;
      stageVar('--cm-stage-ratio', ratioVar(r));
      setOrient(r);
      return true;
    }

    function syncSound() {
      player.dataset.muted = video.muted ? '1' : '0';
      if (soundBtn) {
        var txt = label(video.muted ? 'unmute' : 'mute');
        if (txt) soundBtn.setAttribute('aria-label', txt);
      }
    }

    function isLastSlide(b, s) {
      return b === bubbles.length - 1 && s === counts[b] - 1;
    }

    function playVideo() {
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          /* Le son a été refusé (politique d'autoplay) : on retombe sur une
             lecture muette plutôt que sur une image fixe, et le bouton son
             dit la vérité. */
          if (kind !== 'video' || !isOpen) return;
          video.muted = true;
          syncSound();
          var r = video.play();
          if (r && r.catch) r.catch(function () {});
        });
      }
    }

    function showVideo(slide, last, first, preset) {
      stopImage();
      if (img) img.hidden = true;
      video.hidden = false;
      var same = video.getAttribute('src') === slide.src;
      if (!same) {
        /* Première ouverture : on repart du 16/9 par défaut tant que les
           métadonnées manquent. En navigation, l'ancien ratio reste jusqu'aux
           nouvelles, pour ne pas faire sauter la scène deux fois.
           ★ 22/10 (15h10) : sauf si le ratio est déjà connu (`preset`). */
        if (first && !preset) {
          stageVar('--cm-stage-ratio', '');
          setOrient(0);
        }
        video.setAttribute('src', slide.src);
      } else {
        try {
          if (video.currentTime) video.currentTime = 0;
        } catch (e) {
          /* source non cherchable */
        }
        if (video.readyState >= 1 && video.videoWidth) applyRatio();
      }
      video.controls = false;
      /* Les vidéos jouent une fois puis enchaînent ; seule la toute dernière
         diapo de la story boucle (spec § 5.3). */
      video.loop = last;
      video.muted = slide.mode === 'ambient';
      syncSound();
      video.preload = 'auto';
      playVideo();
    }

    /* ---- Minuteur des images ---------------------------------------------- */
    var imgElapsed = 0;
    var imgStart = 0;
    var imgRunning = false;
    var imgTimer = 0;
    var imgWaiting = false; /* image pas encore chargée : le compteur attend */

    function now() {
      return new Date().getTime();
    }
    /* ★ 22/10 (15h10) · BARRE LISSE : le segment d'une image avance à
       chaque image d'animation (avant : tous les 100 ms, par à-coups). Repli
       sur le minuteur sans `requestAnimationFrame`. */
    function cancelImageTick() {
      if (RAF) window.cancelAnimationFrame(imgTimer);
      else window.clearTimeout(imgTimer);
      imgTimer = 0;
    }
    function queueImageTick() {
      imgTimer = RAF ? window.requestAnimationFrame(tickImage) : window.setTimeout(tickImage, IMAGE_TICK);
    }
    function tickImage() {
      cancelImageTick();
      if (!imgRunning) return;
      var e = imgElapsed + (now() - imgStart);
      setSegFill(pos.slide, e / IMAGE_MS);
      if (e >= IMAGE_MS) {
        imgRunning = false;
        imgElapsed = IMAGE_MS;
        player.dataset.playing = '0';
        advance();
        return;
      }
      queueImageTick();
    }
    function startImage() {
      imgElapsed = 0;
      imgWaiting = false;
      /* Image arrivée pendant un appui long : le compteur attend le relâché
         (`resumePlayback` le lance). */
      if (held) {
        imgRunning = false;
        player.dataset.playing = '0';
        return;
      }
      imgRunning = true;
      imgStart = now();
      player.dataset.playing = '1';
      tickImage();
    }
    function pauseImage() {
      if (!imgRunning) return;
      imgElapsed += now() - imgStart;
      imgRunning = false;
      cancelImageTick();
      player.dataset.playing = '0';
    }
    function resumeImage() {
      if (imgRunning || imgWaiting || imgElapsed >= IMAGE_MS) return;
      imgRunning = true;
      imgStart = now();
      player.dataset.playing = '1';
      tickImage();
    }
    function stopImage() {
      imgRunning = false;
      imgWaiting = false;
      cancelImageTick();
    }

    function imageUrl(src) {
      return cdnWidth(src, isMobile() ? 1600 : 1080);
    }

    function showImage(slide) {
      stopImage();
      video.pause();
      video.hidden = true;
      if (!img) {
        img = document.createElement('img');
        img.className = 'csm-video-player__img';
        img.alt = '';
        img.decoding = 'async';
        img.addEventListener('load', function () {
          applyImageRatio();
          if (imgWaiting && kind === 'image' && isOpen) startImage();
        });
        img.addEventListener('error', function () {
          /* Image illisible : le compteur tourne quand même, la story avance. */
          if (imgWaiting && kind === 'image' && isOpen) startImage();
        });
        stage.insertBefore(img, video.nextSibling);
      }
      img.hidden = false;
      var url = imageUrl(slide.src);
      if (img.getAttribute('src') !== url) {
        img.removeAttribute('data-orient');
        /* `sizes` et `srcset` avant `src` : une seule requête, à la bonne largeur. */
        var set = imageSrcset(slide.src);
        if (set) {
          img.sizes = IMAGE_SIZES;
          img.srcset = set;
        } else {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
        img.src = url;
      }
      /* Le compteur part quand l'image est là : pas de 5 s sur un écran noir. */
      if (img.complete && img.naturalWidth) {
        applyImageRatio();
        startImage();
      } else {
        imgWaiting = true;
        player.dataset.playing = '0';
      }
    }

    function preloadNext(b, s) {
      var n = nextSlide(b, s, counts);
      if (!n) return;
      var slide = slidesOf[n.bubble][n.slide];
      if (slide.type !== 'image') return;
      var pre = new Image();
      pre.decoding = 'async';
      /* Mêmes `sizes` et `srcset` que la diapo : le navigateur choisit la même
         largeur, la diapo suivante sort du cache. */
      var set = imageSrcset(slide.src);
      if (set) {
        pre.sizes = IMAGE_SIZES;
        pre.srcset = set;
      }
      pre.src = imageUrl(slide.src);
    }

    /* ★ FINITION (21/10, retour de Raphaël) · FOND D'AMBIANCE
       Une vidéo paysage dans la carte 9/16 laissait deux grands aplats noirs.
       La scène peint derrière le média l'affiche de la diapo, floutée et
       assombrie (`::before`, voir le CSS) : la variable porte l'URL, à 480 px
       de large (le flou de 28 px n'a pas besoin de plus). Pas de second
       <video>. */
    function setAmbient(poster) {
      if (!stage) return;
      var v = cssUrl(cdnWidth(poster, 480));
      if (v) stage.style.setProperty('--csm-stage-poster', v);
      else stage.style.removeProperty('--csm-stage-poster');
    }
    /* Orientation du média, lue par le CSS de la scène : en portrait le média
       remplit la scène, le fond d'ambiance est retiré. ★ Lot 2 : `upright`
       (3/4) garde le fond d'ambiance et le média entier (`orientOf`). */
    /* ★ 22/10 (15h10) : aussi sur le lecteur, pour la carte d'ordinateur
       qui s'adapte à l'orientation de la diapo (CSS, section 2 ter). */
    function setOrient(r) {
      var o = orientOf(r);
      if ((player.getAttribute('data-orient') || '') !== o) markSizing();
      if (o) player.setAttribute('data-orient', o);
      else player.removeAttribute('data-orient');
      if (!stage) return;
      if (o) stage.setAttribute('data-orient', o);
      else stage.removeAttribute('data-orient');
      fillRatio = r > 0 ? r : 0;
      syncFill();
      scheduleChrome();
    }

    /* ★ 22/10 (21h03) · PLEIN CADRE DU 3/4 AU TÉLÉPHONE (`fillOf`). Relu
       quand le ratio du média change (`setOrient`), à l'ouverture
       (`syncViewport`) et à chaque changement de taille de la scène
       (rotation, barres de Safari, plein écran : `ResizeObserver`, et les
       événements de `queueViewport`). Scène sans taille (lecteur caché) :
       pas de plein cadre. Téléphone couché : jamais.
       ★ 22/10 (23h21) : l'ordinateur aussi. Sa carte debout prend le ratio
       du média (CSS, bloc « 23h21 ») : la scène vaut le 3/4 à un ou deux
       pixels près, que `cover` absorbe sans rognage visible. En plein écran,
       la scène a la forme de l'écran : le rognage dépasse le seuil, `contain`
       comme avant. */
    var fillRatio = 0;
    function syncFill() {
      if (!stage) return;
      var on = false;
      if (fillRatio > 0 && !(isMobile() && isLand())) {
        var w = stage.clientWidth;
        var h = stage.clientHeight;
        on = w > 0 && h > 0 && fillOf(fillRatio, w / h);
      }
      if (on) stage.setAttribute('data-fill', '1');
      else stage.removeAttribute('data-fill');
    }
    if (stage && window.ResizeObserver) {
      new window.ResizeObserver(function () {
        syncFill();
      }).observe(stage);
    }

    /* ★ 22/10 (15h10) · CARTE D'ORDINATEUR COUCHÉE. Sa hauteur est celle de
       la scène au ratio de la diapo plus le reste (segments, en-tête, corps,
       bouton d'achat). Ce reste dépend du texte et de la largeur : mesuré ici
       (hauteur de la carte moins celle de la scène), posé en `--csm-chrome`,
       relu après chaque changement de diapo, de taille et de transition. */
    /* ★ 22/10 (23h21) · Le reste se mesure carte AU REPOS (voir `chromeOf`,
       `sizingWait`) : pendant une transition de largeur, la mesure faite sur
       la carte encore étroite enfermait la carte large à 1 px de large. Carte
       debout (`upright`) : même mesure, dans `--csm-pchrome`, pour que la
       scène prenne le ratio du média. Au plus `CHROME_RUNS` réglages par
       changement de diapo ou de taille d'écran (pas de va-et-vient). */
    var chromeRaf = 0;
    var chromeTimer = 0;
    var chromeRuns = 0;
    var CHROME_RUNS = 6;
    var sizingUntil = 0;
    function markSizing() {
      sizingUntil = now() + EXIT_MS + 120;
    }
    function boxResizing() {
      if (!box || !box.getAnimations) return false;
      try {
        var a = box.getAnimations();
        for (var i = 0; i < a.length; i++) {
          var p = a[i].transitionProperty;
          if ((p === 'width' || p === 'height') && a[i].playState === 'running') return true;
        }
      } catch (e) {
        /* navigateur sans `getAnimations` fiable : le minuteur suffit */
      }
      return false;
    }
    function measureChrome() {
      chromeRaf = 0;
      if (!isOpen || !stage || isMobile() || isFull()) return;
      var o = player.getAttribute('data-orient');
      var name = o === 'landscape' ? '--csm-chrome' : o === 'upright' ? '--csm-pchrome' : '';
      if (!name) return;
      var wait = sizingWait(sizingUntil, now(), boxResizing());
      if (wait > 0) {
        window.clearTimeout(chromeTimer);
        chromeTimer = window.setTimeout(scheduleChrome, Math.ceil(wait) + 20);
        return;
      }
      var c = Math.round(chromeOf(box.clientHeight, stage.offsetHeight, chromeCap(window.innerHeight, o)));
      if (!(c > 0)) return;
      var cur = parseFloat(box.style.getPropertyValue(name)) || 0;
      if (Math.abs(c - cur) > 1 && chromeRuns < CHROME_RUNS) {
        chromeRuns += 1;
        stageVar(name, c + 'px');
        /* La carte se recale : nouvelle mesure une fois au repos. */
        scheduleChrome();
      }
    }
    function scheduleChrome() {
      if (chromeRaf) return;
      if (RAF) chromeRaf = window.requestAnimationFrame(measureChrome);
      else {
        chromeRaf = 1;
        window.setTimeout(measureChrome, 16);
      }
    }

    /* ★ RETOURS DE RAPHAËL (22/10, 15h40) · CALQUES DES BULLES VOISINES
       Ordinateur, carte large : la bulle suivante (et la précédente) est
       une carte voisine, à l'écart de la carte (★ 16h04 : plus un calque
       derrière elle ; CSS, section 2 ter). Vrai quand ces voisines sont à
       l'écran : même requête que le CSS (1 100 px et plus, ni téléphone ni
       plein écran), carte couchée, deux bulles au moins. */
    var REDUCED = '(prefers-reduced-motion: reduce)';
    function layersOn() {
      return (
        isOpen &&
        bubbles.length > 1 &&
        !isMobile() &&
        !isFull() &&
        player.getAttribute('data-orient') === 'landscape' &&
        window.matchMedia('(min-width: 1100px)').matches
      );
    }
    /* ★ 22/10 (16h04) · CHANGEMENT DE BULLE DEPUIS UNE VOISINE (FLIP).
       Avant le changement, `layerFrom` relève la carte et la voisine cliquée
       (centre de sa partie visible : celui de sa flèche). Après, `layerSwap`
       anime : la nouvelle carte part de la place de la voisine (réduite à sa
       hauteur, opacité .7) et vient devant ; l'ancienne carte devient la
       voisine de l'autre côté (elle y glisse depuis le centre, en fondu) ;
       la voisine du côté cliqué, qui montre désormais la bulle d'après,
       entre en fondu en glissant de l'extérieur. Animations Web (`animate`), rien sous
       `prefers-reduced-motion` : le changement est alors net. */
    function rectOf(el) {
      var r = el && el.getBoundingClientRect();
      return r && r.width && r.height ? r : null;
    }
    function layerFrom(dir) {
      var side = dir === 'next' ? sideAfter : sideBefore;
      var arrow = dir === 'next' ? nextBtn : prevBtn;
      var from = rectOf(side);
      var old = rectOf(box);
      if (!from || !old) return null;
      var a = rectOf(arrow);
      return {
        dir: dir,
        old: old,
        h: from.height,
        x: a ? a.left + a.width / 2 : from.left + from.width / 2,
        y: from.top + from.height / 2
      };
    }
    /* ★ 23h21 : animations en cours d'un changement de bulle, arrêtées par
       `stopSwap` (nouveau clic, fermeture) : aucun état d'animation ne reste
       accroché à la carte ou aux voisines. */
    var swapAnims = [];
    function stopSwap() {
      var list = swapAnims;
      swapAnims = [];
      for (var i = 0; i < list.length; i++) {
        try {
          list[i].cancel();
        } catch (e) {
          /* déjà finie */
        }
      }
    }
    function track(an) {
      if (an) swapAnims.push(an);
      return an;
    }
    function layerSwap(pre) {
      if (!pre || !box.animate || window.matchMedia(REDUCED).matches) return;
      var dur = EXIT_MS + 140;
      var ease = 'cubic-bezier(0.2, 0.7, 0.2, 1)';
      var next = pre.dir === 'next';
      try {
        var nb = rectOf(box);
        if (!nb) return;
        var s = pre.h / nb.height;
        track(box.animate(
          [
            {
              transform: 'translate(' + (pre.x - (nb.left + nb.width / 2)) + 'px, ' + (pre.y - (nb.top + nb.height / 2)) + 'px) scale(' + s + ')',
              opacity: 0.7
            },
            { transform: 'translate(0, 0) scale(1)', opacity: 1 }
          ],
          { duration: dur, easing: ease }
        ));
        /* L'ancienne carte, devenue voisine de l'autre côté : elle glisse
           depuis la place de la carte vers la sienne et s'éclaire en fondu,
           comme un carrousel qui avance d'un cran (pas de copie de la carte :
           la voisine montre son affiche, pas la vidéo). */
        var other = next ? sideBefore : sideAfter;
        var R = other && other.firstChild ? rectOf(other) : null;
        if (R && other.animate) {
          var cs = window.getComputedStyle(other);
          var k = parseFloat(cs.getPropertyValue('--csm-nb-scale')) || 0.96;
          var shift = Math.round(Math.min(pre.old.width / 3, 260)) * (next ? 1 : -1);
          track(other.animate(
            [
              { transform: 'translateX(' + shift + 'px) scale(' + k + ')', opacity: 0 },
              { transform: 'scale(' + k + ')', opacity: parseFloat(cs.opacity) || 0.7 }
            ],
            { duration: dur, easing: ease }
          ));
          var arrow = next ? prevBtn : nextBtn;
          if (arrow && !arrow.hidden && arrow.animate) {
            track(arrow.animate([{ opacity: 0 }, { opacity: 1 }], { duration: dur, easing: 'ease-out' }));
          }
        }
        /* La voisine du côté cliqué montre la bulle d'après : fondu. */
        var same = next ? sideAfter : sideBefore;
        if (same && same.firstChild && same.animate) {
          var k2 = parseFloat(window.getComputedStyle(same).getPropertyValue('--csm-nb-scale')) || 0.96;
          var op = parseFloat(window.getComputedStyle(same).opacity) || 0.7;
          track(same.animate(
            [
              { transform: 'translateX(' + (next ? 40 : -40) + 'px) scale(' + k2 + ')', opacity: 0 },
              { transform: 'scale(' + k2 + ')', opacity: op }
            ],
            { duration: dur, easing: ease }
          ));
        }
      } catch (err) {
        /* animation refusée : le changement reste net */
      }
    }

    /* ---- Aller à une diapo ------------------------------------------------- */
    function goTo(b, s, first) {
      if (b < 0 || b >= bubbles.length) return;
      s = Math.max(0, Math.min(s, counts[b] - 1));
      var newBubble = b !== pos.bubble;
      /* ★ 23h21 : un clic pendant l'animation d'un changement de bulle
         l'arrête net (la carte reprend sa place avant le relevé) ; nouveaux
         réglages du reste permis pour la nouvelle diapo. */
      stopSwap();
      chromeRuns = 0;
      /* ★ 22/10 (16h04) : relevé avant changement, si la bulle visée n'est pas
         connue pour être portrait (la carte large reste large). */
      var rb = ratios[slidesOf[b][0].src];
      var swap =
        !first && newBubble && pos.bubble >= 0 && layersOn() && !(rb > 0 && rb < 1)
          ? layerFrom(b > pos.bubble ? 'next' : 'prev')
          : null;
      var slide = slidesOf[b][s];
      var card = bubbles[b];
      pos = { bubble: b, slide: s };
      current = card;
      kind = slide.type;
      mode = kind === 'image' ? 'image' : slide.mode;
      player.dataset.mode = mode;
      player.dataset.kind = kind;
      /* ★ 22/10 (15h10) : pas de double barre sur un film seul. */
      player.setAttribute('data-segs', segsVisibles(counts[b], mode) ? '1' : '0');
      clearRotateHint();
      held = false;
      player.removeAttribute('data-held');

      if (newBubble || first) {
        fillHead(b);
        markSeen(b);
        /* ★ 22/10 (17h41) : chevron et cartes voisines du défilement
           (téléphone) ; un indice de départ en cours s'arrête. */
        if (!first) endPeek();
        resetUpnext(b, first);
        fillPanels(b);
      }
      elTitle.textContent = slide.title || decodeEntities(card.dataset.title);
      elText.textContent = slide.text || decodeEntities(card.dataset.text);
      buildSegments(b);
      markSegments(s);
      buildSides(b);

      setAmbient(slide.poster || slidesOf[b][0].poster || card.dataset.poster);
      var preset = presetRatio(slide);
      if (kind === 'image') showImage(slide);
      else showVideo(slide, isLastSlide(b, s), first, preset);
      if (swap) layerSwap(swap);
      paintProgress();
      scheduleChrome();
      preloadNext(b, s);
      syncRemain();
      if (kind === 'video' || isFull()) setCtrl(true);
      else setCtrl(false);
      syncPlayBtn();
    }

    /* Fin d'une diapo (vidéo `ended`, minuteur d'image écoulé). */
    function advance() {
      var n = nextSlide(pos.bubble, pos.slide, counts);
      if (n) {
        goTo(n.bubble, n.slide);
        return;
      }
      /* Dernière diapo de la dernière bulle. Vidéo : `loop` est déjà posé, le
         navigateur n'émet pas `ended` ; filet si la source l'émet quand même.
         Image : elle reste affichée, segment plein, minuteur arrêté. */
      if (kind === 'video') {
        video.loop = true;
        try {
          video.currentTime = 0;
        } catch (e) {}
        playVideo();
      } else {
        setSegFill(pos.slide, 1);
      }
    }

    /* Gestes et clavier : suivante, ou fermeture après la dernière. */
    function goNext() {
      var n = nextSlide(pos.bubble, pos.slide, counts);
      if (n) goTo(n.bubble, n.slide);
      else close();
    }
    /* Précédente ; sur la toute première, on la relance depuis le début. */
    function goPrev() {
      var p = prevSlide(pos.bubble, pos.slide, counts);
      goTo(p.bubble, p.slide);
    }

    function isPaused() {
      if (kind === 'image') return !imgRunning;
      return video.paused;
    }
    function pausePlayback() {
      if (kind === 'image') pauseImage();
      else video.pause();
    }
    function resumePlayback() {
      if (kind === 'image') resumeImage();
      else playVideo();
    }
    function togglePlayback() {
      if (isPaused()) resumePlayback();
      else pausePlayback();
    }

    /* ★ RETOURS DE RAPHAËL (22/10, 15h40) · BOUTON PAUSE / LECTURE
       Rangée basse du mode film, à gauche de la barre : icône pause pendant
       la lecture, triangle en pause (`data-state`, lu par le CSS) ; son nom
       vient du Liquid (`data-label-pause`, `data-label-resume`). Relu à
       chaque `play` / `pause` de la vidéo et à chaque diapo. */
    function syncPlayBtn() {
      if (!playBtn) return;
      var paused = isPaused();
      playBtn.setAttribute('data-state', paused ? 'paused' : 'playing');
      var txt = label(paused ? 'resume' : 'pause');
      if (txt) playBtn.setAttribute('aria-label', txt);
    }

    /* ======================================================================
       4 · Contrôles maison
       ====================================================================== */
    /* ★ MODE FILM (22/10, retour de Raphaël de 00h23 après essai sur son
       téléphone) : une vidéo longue avec son (atelier, lavables) garde ses
       contrôles EN PERMANENCE : curseur épais, temps restant, son, plein
       écran. Plus de fondu, ni pendant l'indication de rotation. Les boucles
       `ambient` et les images gardent le style story (fondu après 2 s). */
    function isFilm() {
      return isOpen && kind === 'video' && mode === 'film';
    }
    /* Contrôles permanents : film, téléphone debout ou ordinateur. Couché,
       plein écran maison : surimpressions effacées après 3 s (22/10, 00h33). */
    function filmCtrl() {
      return isFilm() && !isLand();
    }
    function setCtrl(on) {
      window.clearTimeout(hideTimer);
      if (filmCtrl()) {
        player.dataset.ctrl = 'on';
        return;
      }
      if (rotActive) {
        player.dataset.ctrl = 'off';
        return;
      }
      player.dataset.ctrl = on ? 'on' : 'off';
      /* En pause, les contrôles restent : rien ne bouge, rien à masquer. */
      if (on && !isPaused()) {
        hideTimer = window.setTimeout(function () {
          if (filmCtrl()) return;
          /* Geste en cours sur une barre : on attend le relâché (qui réarme). */
          if (scrub) return;
          player.dataset.ctrl = 'off';
        }, isFilm() ? CTRL_HIDE_LAND : CTRL_HIDE);
      }
    }

    function maybeRotateHint() {
      /* ★ Lot 2 (22/10) : pas d'invitation à tourner le téléphone devant une
         vidéo debout (9/16, 3/4) : couchée, elle serait plus petite. Le ratio
         inconnu à l'ouverture garde le comportement d'avant. */
      var o = player.getAttribute('data-orient');
      if (o === 'portrait' || o === 'upright') return;
      var seen = false;
      try {
        seen = window.sessionStorage.getItem(KEY_ROT) === '1';
      } catch (e) {
        /* stockage refusé : on montre l'indication, une fois par ouverture */
      }
      if (seen || !rot) return;
      try {
        window.sessionStorage.setItem(KEY_ROT, '1');
      } catch (e) {}
      rotActive = true;
      rot.hidden = false;
      /* Mode film : les contrôles restent (voir `setCtrl`). */
      if (!filmCtrl()) player.dataset.ctrl = 'off';
      window.clearTimeout(hideTimer);
      window.clearTimeout(rotTimer);
      rotTimer = window.setTimeout(function () {
        rot.hidden = true;
        rotActive = false;
        setCtrl(true);
      }, ROT_MS);
    }

    function clearRotateHint() {
      window.clearTimeout(rotTimer);
      rotActive = false;
      if (rot) rot.hidden = true;
    }

    /* ★ Plein écran maison (22/10, 00h33) : à la rotation, sans attendre de
       tap. Le CSS met la scène bord à bord ; ici, l'invitation à tourner
       s'efface et les contrôles repartent (permanents debout, 3 s couché). */
    /* ★ RETOURS DE RAPHAËL (22/10, 15h10) · PAYSAGE ANCRÉ
       Sur iPhone couché, la barre basse tombait au milieu de la vidéo : la
       carte suivait la fenêtre de mise en page, pas la partie visible de
       l'écran (barres de Safari, zoom de la page). Le lecteur reçoit ici la
       taille et la position de l'écran visible (`visualViewport`, sinon
       `innerWidth` / `innerHeight`) : `--csm-vvw`, `--csm-vvh`, `--csm-vvt`,
       `--csm-vvl`. Le CSS du téléphone couché y cale la carte (section 3) :
       ligne du haut et barre basse aux bords visibles, vidéo centrée dans
       la hauteur visible. Relu à chaque redimensionnement, rotation et
       défilement de l'écran visible, une fois par image. */
    var vvRaf = 0;
    function syncViewport() {
      vvRaf = 0;
      if (!isOpen) return;
      var vv = window.visualViewport;
      var w = vv && vv.width ? vv.width : window.innerWidth;
      var h = vv && vv.height ? vv.height : window.innerHeight;
      player.style.setProperty('--csm-vvw', Math.round(w * 100) / 100 + 'px');
      player.style.setProperty('--csm-vvh', Math.round(h * 100) / 100 + 'px');
      player.style.setProperty('--csm-vvt', Math.round((vv ? vv.offsetTop : 0) * 100) / 100 + 'px');
      player.style.setProperty('--csm-vvl', Math.round((vv ? vv.offsetLeft : 0) * 100) / 100 + 'px');
      syncFill();
    }
    function queueViewport() {
      if (!isOpen) return;
      /* ★ 23h21 : la taille de l'écran change celle de la carte (unités vw
         et vh) : nouveaux réglages permis, mesure après la transition. */
      chromeRuns = 0;
      markSizing();
      if (!vvRaf && RAF) vvRaf = window.requestAnimationFrame(syncViewport);
      else if (!RAF) syncViewport();
      scheduleChrome();
    }
    window.addEventListener('resize', queueViewport);
    window.addEventListener('orientationchange', function () {
      queueViewport();
      /* iOS ne donne parfois la nouvelle taille qu'un peu après l'événement. */
      window.setTimeout(queueViewport, 350);
    });
    if (window.visualViewport && window.visualViewport.addEventListener) {
      window.visualViewport.addEventListener('resize', queueViewport);
      window.visualViewport.addEventListener('scroll', queueViewport);
    }
    /* Carte d'ordinateur : la mesure du « reste » se refait au bout de sa
       transition de taille (largeur, hauteur). */
    box.addEventListener('transitionend', function (e) {
      if (e.target === box && (e.propertyName === 'width' || e.propertyName === 'height')) scheduleChrome();
    });

    var landMql = window.matchMedia(LANDSCAPE);
    var onLandChange = function () {
      if (!isOpen) return;
      queueViewport();
      if (isLand()) clearRotateHint();
      setCtrl(true);
    };
    if (landMql.addEventListener) landMql.addEventListener('change', onLandChange);
    else if (landMql.addListener) landMql.addListener(onLandChange);

    /* ★ RELECTURE FINALE (21/10) · Clavier : un bouton de contrôle qui reçoit
       le focus réveille les contrôles (le CSS les garde visibles tant que le
       focus est dedans, `:focus-within`). */
    if (ctrlBox) {
      ctrlBox.addEventListener('focusin', function () {
        if (isOpen) setCtrl(true);
      });
    }

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!isOpen) return;
        if (held) {
          held = false;
          player.removeAttribute('data-held');
        }
        togglePlayback();
        syncPlayBtn();
        setCtrl(true);
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        syncSound();
        setCtrl(true);
      });
    }

    /* ★ FINITION (21/10, retour de Raphaël sur ordinateur) · PLEIN ÉCRAN
       Avant : la cible était la scène, ou le plein écran natif du <video>
       (`webkitEnterFullscreen` existe aussi dans Chrome de bureau). Le <video>
       ne reçoit aucun pointeur (`pointer-events: none`) : ses contrôles natifs
       étaient morts, on ne sortait que par Échap.
       Désormais :
       - ordinateur : toute la carte (`__box` : segments, en-tête, scène, corps,
         bouton d'achat) passe en plein écran, contrôles maison compris ;
       - téléphone : la scène (API standard) ; plein écran natif du <video>
         seulement sans API standard sur un élément (iPhone) ;
       - le bouton bascule : il entre si rien n'est en plein écran, sort sinon ;
       - `fullscreenchange` pose `data-full` sur le lecteur (le CSS garde la
         croix dans l'en-tête et montre l'icône de sortie) et met à jour le
         nom du bouton. */
    function fsElement() {
      return document.fullscreenElement || document.webkitFullscreenElement || null;
    }
    function exitFull() {
      var x = null;
      if (document.exitFullscreen) x = document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      if (x && x.catch) x.catch(function () {});
    }
    function enterFull(el) {
      if (!el) return false;
      var r = null;
      if (el.requestFullscreen) r = el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      else return false;
      if (r && r.catch) r.catch(function () {});
      return true;
    }
    function isFull() {
      return player.getAttribute('data-full') === '1';
    }
    function syncFull() {
      var on = !!fsElement() && isOpen;
      player.setAttribute('data-full', on ? '1' : '0');
      if (fullBtn) {
        var txt = label(on ? 'full-exit' : 'full');
        if (txt) fullBtn.setAttribute('aria-label', txt);
      }
      if (isOpen) setCtrl(true);
    }
    document.addEventListener('fullscreenchange', syncFull);
    document.addEventListener('webkitfullscreenchange', syncFull);

    if (fullBtn) {
      fullBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (fsElement()) {
          exitFull();
          setCtrl(true);
          return;
        }
        if (isMobile()) {
          /* ★ RELECTURE TASK 6 : la scène d'abord (nos contrôles restent
             vivants, le bouton ressort). `webkitEnterFullscreen` existe aussi
             dans Chromium (Android, fenêtre étroite d'ordinateur) : appelé en
             premier, il remettait la vidéo seule en plein écran natif, sans
             pointeur, sans sortie. Il ne sert plus que là où l'API standard
             manque sur un élément : l'iPhone. */
          if (!enterFull(stage) && kind === 'video' && typeof video.webkitEnterFullscreen === 'function') {
            try {
              video.webkitEnterFullscreen();
              return;
            } catch (err) {
              /* rien d'autre à tenter */
            }
          }
        } else if (!enterFull(box)) {
          enterFull(stage);
        }
        setCtrl(true);
      });
    }

    /* ======================================================================
       4 bis · ★ RETOURS DE RAPHAËL (21/10, 23h34) · CURSEUR DE LECTURE
       Avant les bulles, le lecteur avait une barre de lecture et un compteur
       de temps restant ; la barre segmentée ne cherchait plus qu'au clic
       précis sur un trait de 2,5 px. Elle redevient un curseur, au doigt
       comme à la souris :
       - appui sur le segment COURANT : la lecture va sous le doigt, puis
         suit le glissement (capture du pointeur) ; un tap simple cherche
         aussi. Vidéo : `currentTime`, posé une fois par image d'animation,
         jamais tout au bout pendant le geste (`ended` enchaînerait sous le
         doigt). Image : le minuteur avance ou recule, puis reprend au
         relâché ; glissé jusqu'au bout, la diapo suivante vient ;
       - appui sur un AUTRE segment : cette diapo s'ouvre au relâché, comme
         avant ;
       - pendant le geste, `data-scrub="1"` épaissit la barre (CSS), les
         contrôles se montrent, le glissement vers le bas de la carte ne part
         pas (la carte écarte `__segs`), et le `click` qui suit est avalé
         (`swallowUntil`, même fenêtre que les taps de la scène).
       ====================================================================== */
    var scrub = null; /* geste en cours sur la barre */
    var seekRaf = 0;
    var seekTo = -1;

    function segRects() {
      var list = segEls();
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        out.push({ left: r.left, right: r.right });
      }
      return out;
    }
    function applySeek() {
      seekRaf = 0;
      if (seekTo < 0 || kind !== 'video') {
        seekTo = -1;
        return;
      }
      try {
        video.currentTime = seekTo;
      } catch (err) {
        /* source non cherchable : on ne fait rien */
      }
      seekTo = -1;
      syncRemain();
    }
    /* `ref` : la piste de la barre basse, ou le segment courant par défaut. */
    function scrubAt(x, ref) {
      var seg = ref || segEls()[pos.slide];
      if (!seg) return;
      var r = seg.getBoundingClientRect();
      var ratio = seekRatio(x, r.left, r.width);
      if (kind === 'image') {
        if (imgWaiting) return;
        imgElapsed = ratio * IMAGE_MS;
        setSegFill(pos.slide, ratio);
        return;
      }
      var d = video.duration;
      if (!isFinite(d) || !d) return;
      setSegFill(pos.slide, ratio);
      seekTo = Math.min(ratio * d, Math.max(0, d - 0.25));
      if (!seekRaf) seekRaf = window.requestAnimationFrame(applySeek);
    }
    function endScrub(e, cancelled) {
      if (!scrub || e.pointerId !== scrub.id) return;
      var g = scrub;
      scrub = null;
      if (g.cap.releasePointerCapture) {
        try {
          g.cap.releasePointerCapture(g.id);
        } catch (err) {
          /* déjà relâché */
        }
      }
      player.removeAttribute('data-scrub');
      swallowUntil = now() + 600;
      if (g.other >= 0) {
        if (!cancelled && isOpen) goTo(pos.bubble, g.other);
        return;
      }
      if (!isOpen) return;
      if (!cancelled) scrubAt(e.clientX, g.track);
      if (seekRaf) {
        window.cancelAnimationFrame(seekRaf);
        applySeek();
      }
      if (kind === 'image' && !imgWaiting) {
        if (imgElapsed >= IMAGE_MS) {
          imgElapsed = IMAGE_MS;
          setSegFill(pos.slide, 1);
          if (!g.wasEnded) advance();
        } else if (g.wasRunning || g.wasEnded) {
          resumeImage();
        }
      }
      syncRemain();
      if (kind === 'video' || isFull()) setCtrl(true);
    }

    /* Début d'un geste : `cap` reçoit la capture, `track` sert de règle (null =
       segment courant), `other` = autre diapo à ouvrir au relâché (-1 sinon). */
    function startScrub(e, cap, track, other) {
      scrub = { id: e.pointerId, cap: cap, track: track, other: other, wasRunning: false, wasEnded: false };
      try {
        cap.setPointerCapture(e.pointerId);
      } catch (err) {
        /* sans capture, le geste s'arrête au bord de la barre */
      }
      if (other >= 0) return;
      player.setAttribute('data-scrub', '1');
      if (kind === 'video' || isFull()) setCtrl(true);
      if (kind === 'image' && !imgWaiting) {
        scrub.wasEnded = imgElapsed >= IMAGE_MS;
        scrub.wasRunning = imgRunning;
        pauseImage();
      }
      scrubAt(e.clientX, track);
    }
    function bindScrub(el, onDown) {
      el.addEventListener('pointerdown', onDown);
      el.addEventListener('pointermove', function (e) {
        if (!scrub) {
          /* Souris : survoler la barre la montre en curseur (contrôles). */
          if (e.pointerType === 'mouse' && isOpen && (kind === 'video' || isFull())) setCtrl(true);
          return;
        }
        if (e.pointerId !== scrub.id || scrub.cap !== el || scrub.other >= 0) return;
        scrubAt(e.clientX, scrub.track);
      });
      el.addEventListener('pointerup', function (e) {
        endScrub(e, false);
      });
      el.addEventListener('pointercancel', function (e) {
        endScrub(e, true);
      });
      el.addEventListener('lostpointercapture', function (e) {
        endScrub(e, true);
      });
    }

    if (elSegs) {
      bindScrub(elSegs, function (e) {
        if (!isOpen || (e.button && e.button !== 0)) return;
        var i = segAt(e.clientX, segRects());
        if (i < 0) return;
        e.preventDefault();
        startScrub(e, elSegs, null, i !== pos.slide ? i : -1);
      });
    }
    /* Barre basse (mode film) : toujours la diapo courante. */
    if (seek) {
      bindScrub(seek, function (e) {
        if (!isOpen || (e.button && e.button !== 0)) return;
        e.preventDefault();
        e.stopPropagation();
        startScrub(e, seek, seekTrack, -1);
      });
    }

    /* Temps restant de la barre basse (`__remain`, mode film, même en pause :
       il dit où l'on est). ★ 22/10 (18h09) : c'est le seul temps affiché ;
       l'en-tête n'en montre plus (retour de Raphaël). */
    function syncRemain() {
      if (!current || !elRemain) return;
      var d = video.duration;
      var known = kind === 'video' && isFinite(d) && d > 0;
      elRemain.textContent = known ? remainingClock(d - video.currentTime) : '';
    }

    /* ★ RETOURS DE RAPHAËL (22/10, 15h10) · BARRE LISSE
       Le remplissage (segment et barre basse) avançait au rythme de
       `timeupdate`, environ 4 fois par seconde : par à-coups. Pendant la
       lecture, une boucle `requestAnimationFrame` le pose à chaque image
       depuis `currentTime`, extrapolé entre deux relevés s'il n'a pas bougé
       (`smoothTime`, au plus PROG_CAP s d'avance, jamais pendant un
       chargement ou une recherche). Elle s'arrête en pause, en fin de
       diapo, sur une image et à la fermeture. Pendant un geste sur une
       barre, le doigt commande (`scrub`) : la boucle ne peint pas. Aucune
       transition CSS sur les largeurs. */
    var progRaf = 0;
    var progRead = -1;
    var progWall = 0;
    function wallNow() {
      return window.performance && window.performance.now ? window.performance.now() : now();
    }
    function paintProgress() {
      if (scrub || kind !== 'video' || pos.slide < 0) return;
      var d = video.duration;
      if (!isFinite(d) || !d) return;
      var t = video.currentTime;
      var w = wallNow();
      if (t !== progRead) {
        progRead = t;
        progWall = w;
      } else if (!video.paused && !video.seeking && video.readyState >= 3) {
        t = smoothTime(t, w - progWall, video.playbackRate, PROG_CAP, d);
      }
      setSegFill(pos.slide, t / d);
    }
    function progTick() {
      progRaf = 0;
      if (!isOpen || kind !== 'video' || video.paused) return;
      paintProgress();
      progRaf = window.requestAnimationFrame(progTick);
    }
    function startProgress() {
      if (!RAF || progRaf || !isOpen || kind !== 'video') return;
      progRaf = window.requestAnimationFrame(progTick);
    }
    function stopProgress() {
      if (progRaf) window.cancelAnimationFrame(progRaf);
      progRaf = 0;
    }

    video.addEventListener('timeupdate', function () {
      if (kind !== 'video' || !isFinite(video.duration) || !video.duration) return;
      /* La boucle peint pendant la lecture ; sinon (pause, repli sans
         `requestAnimationFrame`), on peint ici. Pendant un geste, la barre
         suit le doigt, pas la lecture (`paintProgress` le sait). */
      if (!progRaf) paintProgress();
      syncRemain();
      upnextEnd();
    });
    video.addEventListener('playing', startProgress);
    video.addEventListener('seeked', paintProgress);
    video.addEventListener('ended', function () {
      stopProgress();
      if (!isOpen || kind !== 'video') return;
      setSegFill(pos.slide, 1);
      advance();
    });
    /* ★ RELECTURE FINALE (21/10) · Source illisible (HLS `.m3u8` sur Firefox
       de bureau et Chrome Android, fichier absent) : le lecteur ne reste pas
       sur un écran noir. Diapo suivante s'il y en a une, sinon fermeture.
       Seule l'erreur de la source COURANTE compte (`currentSrc` du moment) ;
       la fermeture retire la source sans en provoquer (pas de `src`). */
    video.addEventListener('error', function () {
      if (!isOpen || kind !== 'video' || !video.getAttribute('src')) return;
      var n = nextSlide(pos.bubble, pos.slide, counts);
      if (n) goTo(n.bubble, n.slide);
      else close();
    });
    video.addEventListener('play', function () {
      if (kind !== 'video') return;
      startProgress();
      player.dataset.playing = '1';
      syncPlayBtn();
      if (player.dataset.ctrl === 'on') setCtrl(true);
    });
    video.addEventListener('pause', function () {
      stopProgress();
      if (kind !== 'video') return;
      paintProgress();
      player.dataset.playing = '0';
      syncPlayBtn();
      window.clearTimeout(hideTimer);
      syncRemain();
      /* Appui long : l'écran reste nu, comme sur Instagram. */
      if (isOpen && !rotActive && !held) player.dataset.ctrl = 'on';
    });

    /* ---- Gestes sur la scène ----------------------------------------------
       Mobile (doigt, ou requête MOBILE) : tiers gauche = précédente, tiers
       droit = suivante (après la dernière : ferme), tiers central = contrôles.
       Partout : appui long (HOLD_MS) = pause, relâcher = reprise. Ordinateur,
       souris : un clic court = pause / lecture. Les boutons de la scène (son,
       plein écran) gardent leur propre sens. */
    var press = null;
    var holdTimer = 0;
    var held = false;
    /* Le navigateur émet un `click` APRÈS le tap, situé de nouveau sous le
       doigt. Si la diapo suivante a changé la mise en page (autre ratio, autre
       carte), ce point peut tomber hors de la carte, et la sortie au clic
       fermerait la story qu'on vient de faire avancer (mesuré le 21/10 sans le
       CSS : carte de 89 à 133 px, `click` sur `__frame`). Un tap ou un appui
       traité ici neutralise donc le `click` qui le suit.
       ★ RELECTURE TASK 4 : le même `click` peut tomber sur un BOUTON du
       lecteur remonté sous le doigt (bouton d'achat quand le texte change de
       hauteur : fermeture puis ajout au panier involontaire ; croix, aperçus,
       flèches). L'écoute est donc posée EN CAPTURE sur tout le lecteur : elle
       passe avant celles des boutons, et le `click` avalé n'atteint personne. */
    var swallowUntil = 0;
    player.addEventListener(
      'click',
      function (e) {
        if (!swallowUntil) return;
        var due = now() < swallowUntil;
        swallowUntil = 0;
        if (!due) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      },
      true
    );

    function touchLike(e) {
      return e.pointerType === 'touch' || e.pointerType === 'pen' || isMobile() || window.matchMedia('(pointer: coarse)').matches;
    }

    /* ---- ★ RETOURS DE RAPHAËL (22/10, 17h41) · DÉFILEMENT VERTICAL ---------
       Façon reels, remplace le glissement latéral de 17h06. Téléphone
       (requête MOBILE, couché compris), hors plein écran API. Un geste
       vertical net (`gesteScene`), commencé sur la scène, l'en-tête, le corps
       ou la poignée, emporte la carte sous le doigt ; la carte voisine
       (`fillPanel`) suit, collée à elle : la suivante dessous, la précédente
       dessus. Au relâché (`swipeDecision`) : vers le haut = bulle suivante,
       ou retour élastique sur la dernière (résistance x 0,3) ; vers le bas =
       bulle précédente, ou fermeture sur la première (la carte descend et
       révèle la page, comme le glissement d'avant). Un geste horizontal ne
       fait rien. Animation : transitions CSS de `.is-settling` ; sans
       mouvement (`prefers-reduced-motion`), la carte ne suit pas le doigt et
       la bascule est immédiate. Barre basse, segments et boutons : leurs
       gestes à eux (recherche, clic), jamais un défilement. */
    var swipe = null; /* glissement vertical en cours */
    var settling = false; /* animation de fin de glissement en cours */
    var settleTimer = 0;
    var boxPress = null; /* appui sur l'en-tête, le corps ou la poignée */
    function reducedMotion() {
      return window.matchMedia(REDUCED).matches;
    }
    function canSwipe() {
      return isOpen && isMobile() && !fsElement() && !settling;
    }
    function swipeTarget(dir) {
      return dir === 'next' ? nextIndex(pos.bubble, bubbles.length) : pos.bubble - 1;
    }
    function panelOf(dir) {
      return dir === 'next' ? swipeNext : swipePrev;
    }
    function setY(node, y) {
      if (node) node.style.transform = 'translateY(' + Math.round(y * 10) / 10 + 'px)';
    }
    function boxHeight() {
      return box.getBoundingClientRect().height || window.innerHeight;
    }
    /* Carte et voisine à `dy` px du doigt. */
    function placeSwipe(dy) {
      var dir = dy < 0 ? 'next' : 'prev';
      var b = swipeTarget(dir);
      var panel = panelOf(dir);
      var other = panelOf(dir === 'next' ? 'prev' : 'next');
      if (other) other.hidden = true;
      var y = b < 0 && dir === 'next' ? dy * SWIPE_RUBBER : dy;
      setY(box, y);
      if (!panel) return;
      if (b < 0) {
        /* Dernière : rien dessous. Première : la page se découvre. */
        panel.hidden = true;
        return;
      }
      fillPanel(panel, b);
      panel.hidden = false;
      setY(panel, y + (dir === 'next' ? swipe.h : -swipe.h));
    }
    function startSwipe(e, p0) {
      endPeek();
      measurePanels();
      syncPanel(swipeNext, nextIndex(pos.bubble, bubbles.length));
      syncPanel(swipePrev, pos.bubble - 1);
      swipe = { id: e.pointerId, x0: p0.x, y0: p0.y, t0: p0.t, h: boxHeight() };
      /* La carte capte le doigt jusqu'au relâché, d'où qu'il soit parti. */
      try {
        box.setPointerCapture(e.pointerId);
      } catch (err) {
        /* sans capture, le geste s'arrête au bord de la carte */
      }
      player.setAttribute('data-swipe', '1');
      if (!reducedMotion()) player.classList.add('is-dragging');
    }
    function moveSwipe(e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      if (!reducedMotion()) placeSwipe(e.clientY - swipe.y0);
    }
    /* Remise à plat sans transition : carte en place, voisines cachées. */
    function clearSwipe() {
      window.clearTimeout(settleTimer);
      settling = false;
      player.classList.add('is-dragging');
      player.classList.remove('is-settling');
      box.style.transform = '';
      [swipeNext, swipePrev].forEach(function (p) {
        if (!p) return;
        p.hidden = true;
        p.style.transform = '';
      });
      /* Une mise en page entre les deux : la remise à zéro ne s'anime pas. */
      void box.offsetWidth;
      player.classList.remove('is-dragging');
      player.removeAttribute('data-swipe');
    }
    /* Fin animée : la carte va à `boxY`, la voisine visible à `panelY`, puis
       `done` (changement de bulle) et remise à plat dans la même image. */
    function settle(boxY, panelY, done) {
      if (reducedMotion() || !RAF) {
        if (done) done();
        clearSwipe();
        return;
      }
      settling = true;
      player.classList.remove('is-dragging');
      player.classList.add('is-settling');
      setY(box, boxY);
      [swipeNext, swipePrev].forEach(function (p) {
        if (p && !p.hidden) setY(p, panelY);
      });
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        if (!isOpen) return;
        if (done) done();
        clearSwipe();
      }, EXIT_MS + 40);
    }
    /* Vers la bulle `b` (suivante si `dir` = 'next'), depuis la position
       actuelle de la carte : la voisine vient à sa place. */
    function settleTo(dir, b, h) {
      settle(dir === 'next' ? -h : h, 0, function () {
        goTo(b, 0);
      });
    }
    function settleBack(h) {
      var dir = swipeNext && !swipeNext.hidden ? 'next' : 'prev';
      settle(0, dir === 'next' ? h : -h);
    }
    function endSwipe(e, cancelled) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var g = swipe;
      swipe = null;
      try {
        box.releasePointerCapture(g.id);
      } catch (err) {
        /* déjà relâché */
      }
      /* Le `click` qui suit le geste n'atteint personne (bouton d'achat). */
      swallowUntil = now() + 600;
      if (!isOpen) return;
      var dx = e.clientX - g.x0;
      var dy = e.clientY - g.y0;
      var dec = cancelled ? '' : swipeDecision(dx, dy, e.timeStamp - g.t0, SWIPE_DISTANCE, SWIPE_VELOCITY, SWIPE_MIN);
      if (!dec) {
        settleBack(g.h);
        return;
      }
      var b = swipeTarget(dec);
      if (b >= 0) {
        settleTo(dec, b, g.h);
      } else if (dec === 'prev') {
        /* Première bulle vers le bas : fermeture ; la carte part de là où le
           doigt l'a laissée. */
        player.classList.remove('is-dragging');
        player.removeAttribute('data-swipe');
        close();
      } else {
        /* Dernière bulle vers le haut : retour élastique, rien ne ferme. */
        settleBack(g.h);
      }
    }
    /* Tap sur le chevron : même montée que le doigt, sans lui. */
    function slideNext() {
      var b = nextIndex(pos.bubble, bubbles.length);
      if (b < 0) return;
      endPeek();
      if (!isMobile() || reducedMotion() || !RAF || !swipeNext || settling) {
        goTo(b, 0);
        return;
      }
      var h = boxHeight();
      measurePanels();
      player.classList.add('is-dragging');
      player.setAttribute('data-swipe', '1');
      fillPanel(swipeNext, b);
      swipeNext.hidden = false;
      if (swipePrev) swipePrev.hidden = true;
      setY(box, 0);
      setY(swipeNext, h);
      void box.offsetWidth;
      settleTo('next', b, h);
    }
    if (upnext) {
      upnext.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!isOpen) return;
        slideNext();
      });
    }

    /* ---- ★ 22/10 (17h41) · INDICE DE DÉPART ---------------------------------
       `PEEK_DELAY` après l'ouverture, une seule fois par ouverture, si une
       bulle suivante existe : la carte se soulève de `PEEK_LIFT` px en
       `PEEK_UP` ms puis redescend (courbe douce), et laisse voir en bas le
       bord supérieur de la carte suivante (en-tête resserré : mini bulle,
       titre court). Animation Web (rien n'est écrit dans `style`) ; annulé
       par tout geste de défilement, un changement de bulle ou la fermeture ;
       rien sous `prefers-reduced-motion`, en plein écran API, pendant un
       appui, une recherche ou une pause. */
    var peekTimer = 0;
    var peekAnims = null;
    function schedulePeek() {
      window.clearTimeout(peekTimer);
      if (!mobileOpen) return;
      peekTimer = window.setTimeout(runPeek, PEEK_DELAY);
    }
    function runPeek() {
      if (!isOpen || !isMobile() || fsElement() || reducedMotion() || !box.animate || !swipeNext) return;
      if (swipe || settling || press || boxPress || held || scrub || isPaused()) return;
      var n = nextIndex(pos.bubble, bubbles.length);
      if (n < 0) return;
      fillPanel(swipeNext, n);
      if (swipePrev) swipePrev.hidden = true;
      var h = boxHeight();
      /* Repos hors de l'écran, sous la carte : ni avant ni après l'animation
         la voisine ne la couvre. */
      setY(swipeNext, h);
      swipeNext.hidden = false;
      player.setAttribute('data-peek', '1');
      var k = PEEK_UP / (PEEK_UP + PEEK_DOWN);
      var frames = function (y0) {
        return [
          { transform: 'translateY(' + y0 + 'px)', easing: PEEK_EASE_UP },
          { offset: k, transform: 'translateY(' + (y0 - PEEK_LIFT) + 'px)', easing: PEEK_EASE_DOWN },
          { transform: 'translateY(' + y0 + 'px)' }
        ];
      };
      var opts = { duration: PEEK_UP + PEEK_DOWN };
      try {
        peekAnims = [box.animate(frames(0), opts), swipeNext.animate(frames(h), opts)];
        peekAnims[0].onfinish = endPeek;
      } catch (err) {
        endPeek();
      }
    }
    function endPeek() {
      window.clearTimeout(peekTimer);
      var anims = peekAnims;
      peekAnims = null;
      if (anims) {
        anims.forEach(function (an) {
          try {
            an.cancel();
          } catch (err) {
            /* déjà fini */
          }
        });
      }
      if (!player.hasAttribute('data-peek')) return;
      player.removeAttribute('data-peek');
      if (!swipe && !settling && swipeNext) {
        swipeNext.hidden = true;
        swipeNext.style.transform = '';
      }
    }

    if (stage) {
      stage.addEventListener('pointerdown', function (e) {
        if (!isOpen || (e.button && e.button !== 0)) return;
        /* ★ 22/10 (17h06) : pas de nouveau geste pendant un glissement ou sa
           fin animée (second doigt, tap pressé). */
        if (swipe || settling) return;
        if (e.target.closest && e.target.closest('button')) return;
        /* Rangée des contrôles (barre basse comprise) : ses gestes à elle. */
        if (e.target.closest && e.target.closest('.csm-video-player__ctrl')) return;
        press = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp, moved: false, touch: touchLike(e) };
        window.clearTimeout(holdTimer);
        holdTimer = window.setTimeout(function () {
          if (!press || press.moved) return;
          held = true;
          player.setAttribute('data-held', '1');
          pausePlayback();
        }, HOLD_MS);
      });
      stage.addEventListener('pointermove', function (e) {
        /* Souris : les contrôles reviennent au mouvement (vidéo ; en plein
           écran aussi sur une image, le bouton de sortie y vit). */
        if (e.pointerType === 'mouse' && isOpen && !press && !swipe && (kind === 'video' || isFull())) setCtrl(true);
        if (!press || e.pointerId !== press.id) return;
        /* ★ 22/10 (17h41) : tri par `gesteScene`. Vertical dominant (haut ou
           bas) = défilement (téléphone) ; sous le seuil = encore un tap ou un
           appui long ; sinon (horizontal, diagonale) le tap est annulé et
           rien ne bouge. Le suivi du doigt passe ensuite par la carte (sa
           capture, ses écoutes). */
        var sens = gesteScene(e.clientX - press.x, e.clientY - press.y, DRAG_SLOP);
        if (sens === 'tap') return;
        press.moved = true;
        window.clearTimeout(holdTimer);
        if (sens !== 'vertical' || !canSwipe()) return;
        var p0 = press;
        press = null;
        if (held) {
          held = false;
          player.removeAttribute('data-held');
          resumePlayback();
        }
        startSwipe(e, p0);
        moveSwipe(e);
      });
      var endPress = function (e, cancelled) {
        if (!press || e.pointerId !== press.id) return;
        var p = press;
        press = null;
        window.clearTimeout(holdTimer);
        if (held) {
          held = false;
          player.removeAttribute('data-held');
          resumePlayback();
          return;
        }
        if (cancelled || p.moved || e.timeStamp - p.t >= HOLD_MS) return;
        /* ★ FINITION (21/10) : la fenêtre d'absorption du `click` n'est armée
           que sur un tap court réel. Après un appui long ou un geste qui a
           bougé, rien ne change sous le doigt ; armée là, elle mangeait le
           premier clic légitime des 600 ms suivantes. */
        swallowUntil = now() + 600;
        if (!p.touch) {
          togglePlayback();
          /* Clic souris sur une image : pas de contrôles (le son n'y a pas de
             sens), sauf en plein écran où vit le bouton de sortie. */
          if (kind === 'video' || isFull()) setCtrl(true);
          return;
        }
        if (rotActive) clearRotateHint();
        /* ★ Plein écran maison (téléphone couché, mode film) : un tap montre
           ou efface les surimpressions, il ne change pas de diapo. */
        if (isFilm() && isLand()) {
          if (player.dataset.ctrl === 'on') {
            window.clearTimeout(hideTimer);
            player.dataset.ctrl = 'off';
          } else {
            setCtrl(true);
          }
          return;
        }
        /* Tiers de la partie VISIBLE de la scène (coupée par la carte). */
        var r = stage.getBoundingClientRect();
        var c = box.getBoundingClientRect();
        var left = Math.max(r.left, c.left);
        var width = Math.max(1, Math.min(r.right, c.right) - left);
        var zone = tapZone(e.clientX - left, width);
        if (zone === 'prev') goPrev();
        else if (zone === 'next') goNext();
        else if (kind === 'video' || isFull()) setCtrl(true);
      };
      stage.addEventListener('pointerup', function (e) {
        endPress(e, false);
      });
      stage.addEventListener('pointercancel', function (e) {
        endPress(e, true);
      });
      /* Un appui long ne doit pas ouvrir le menu contextuel de la vidéo. */
      stage.addEventListener('contextmenu', function (e) {
        if (isOpen) e.preventDefault();
      });
    }

    /* ---- La carte : départ du défilement hors de la scène, suivi, relâché --
       En-tête, corps et poignée (ni la scène, qui trie ses gestes plus haut,
       ni les boutons, ni la barre segmentée, curseur de lecture) : un appui
       devient un défilement dès qu'il est vertical net. Tout glissement en
       cours est suivi ici : la carte capte le doigt (`startSwipe`), et les
       événements de la scène remontent jusqu'à elle avant la capture. */
    box.addEventListener('pointerdown', function (e) {
      if (!canSwipe() || swipe || (e.button && e.button !== 0)) return;
      if (!e.target.closest) return;
      if (e.target.closest('.csm-video-player__stage')) return;
      if (e.target.closest('button')) return;
      if (e.target.closest('.csm-video-player__segs')) return;
      boxPress = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp };
      try {
        box.setPointerCapture(e.pointerId);
      } catch (err) {
        /* sans capture, le geste s'arrête au bord de la carte */
      }
    });
    box.addEventListener('pointermove', function (e) {
      if (swipe) {
        moveSwipe(e);
        return;
      }
      if (!boxPress || e.pointerId !== boxPress.id) return;
      if (gesteScene(e.clientX - boxPress.x, e.clientY - boxPress.y, DRAG_SLOP) !== 'vertical') return;
      var p0 = boxPress;
      boxPress = null;
      if (!canSwipe()) return;
      startSwipe(e, p0);
      moveSwipe(e);
    });
    var endBox = function (e, cancelled) {
      if (boxPress && e.pointerId === boxPress.id) boxPress = null;
      if (swipe) endSwipe(e, cancelled);
    };
    box.addEventListener('pointerup', function (e) {
      endBox(e, false);
    });
    box.addEventListener('pointercancel', function (e) {
      endBox(e, true);
    });
    /* Seulement la capture de la carte elle-même (pas celle, implicite, d'un
       enfant touché, qui remonte jusqu'ici). */
    box.addEventListener('lostpointercapture', function (e) {
      if (e.target !== box) return;
      if (boxPress && e.pointerId === boxPress.id) boxPress = null;
      if (swipe) endSwipe(e, true);
    });

    /* ======================================================================
       5 · Bouton d'achat dans la story (spec § 5.4)
       Le formulaire d'achat de la page : le premier `form[action*="/cart/add"]`
       dont un `[type="submit"]` est visible. Rien n'est réécrit (texte, prix,
       langue, état), aucun appel réseau maison : au clic, on ferme puis on
       clique le vrai bouton, et c'est le thème qui ouvre son tiroir panier,
       avec sa racine de langue. Le bouton n'est cherché que sous un rail de
       fiche (`.csm-videos`) : le bandeau de collection n'en montre jamais, même
       si une vignette d'ajout rapide porte un formulaire.
       ====================================================================== */
    function visibleSubmit(form) {
      var list = form.querySelectorAll('[type="submit"]');
      for (var i = 0; i < list.length; i++) {
        if (list[i].offsetParent !== null) return list[i];
      }
      return null;
    }
    function findCartForm() {
      if (!wrap) return null;
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (player.contains(forms[i])) continue;
        if (visibleSubmit(forms[i])) return forms[i];
      }
      return null;
    }
    function findCartButton() {
      var form = findCartForm();
      return form ? visibleSubmit(form) : null;
    }
    function refreshCta() {
      if (!ctaBtn) return;
      var st = ctaState(findCartButton());
      ctaBtn.hidden = st.hidden;
      if (ctaBtn.textContent !== st.text) ctaBtn.textContent = st.text;
      ctaBtn.disabled = st.disabled;
    }
    function startCta() {
      window.clearInterval(ctaTimer);
      /* Sans rail de fiche (bandeau de collection), jamais de bouton d'achat :
         ni recherche, ni intervalle. */
      if (!wrap) {
        if (ctaBtn) ctaBtn.hidden = true;
        return;
      }
      refreshCta();
      if (ctaBtn) ctaTimer = window.setInterval(refreshCta, CTA_POLL);
    }
    function stopCta() {
      window.clearInterval(ctaTimer);
      ctaTimer = 0;
    }
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var real = findCartButton();
        if (!real || real.disabled || ctaBtn.disabled) return;
        stopImage();
        video.pause();
        close();
        window.setTimeout(function () {
          real.click();
        }, EXIT_MS + 40);
      });
    }

    /* ======================================================================
       6 · Ouverture / fermeture
       ====================================================================== */

    /* ---- ★ VAGUE 4 · Le bouton retour du téléphone -----------------------
       Sans cela, le premier réflexe d'un utilisateur pris dans un lecteur plein
       écran (le retour Android, ou le glissement depuis le bord sur iOS) le
       fait QUITTER la fiche produit. On empile donc un état à l'ouverture, et
       `popstate` devient une fermeture de plus.

       `pushed` dit si l'état empilé est encore le nôtre. Une fermeture par un
       autre geste le dépile (`history.back()`), une fermeture PAR le retour
       remet le drapeau à faux AVANT d'appeler `close()` : jamais deux
       fermetures, jamais un `back()` qui ferait reculer d'une vraie page. */
    var pushed = false;

    function pushHistory() {
      if (pushed) return;
      try {
        window.history.pushState({ cmVideo: true }, '');
        pushed = true;
      } catch (e) {
        pushed = false; /* navigateur qui refuse : les autres sorties restent */
      }
    }
    function popHistory() {
      if (!pushed) return;
      pushed = false;
      try {
        window.history.back();
      } catch (e) {
        /* rien à récupérer */
      }
    }
    window.addEventListener('popstate', function () {
      if (!pushed) return;
      pushed = false;
      if (isOpen) close();
    });

    function open(card) {
      var b = bubbles.indexOf(card);
      if (b < 0) return;
      if (isOpen) {
        goTo(b, 0);
        return;
      }
      opener = card;
      mobileOpen = isMobile();
      pos = { bubble: -1, slide: -1 };
      player.dataset.playing = '1';
      player.dataset.ctrl = 'off';
      /* ★ 22/10 (15h10) : la forme de la carte AVANT de la montrer. Le
         verrou de défilement ci-dessous lit la mise en page : sans cela, la
         carte d'ordinateur naissait en 9/16 puis s'élargissait sous les yeux
         (transition de 260 ms) jusqu'à son format paysage. Ratio inconnu :
         la carte 9/16 par défaut, corrigée à `loadedmetadata`. */
      if (!presetRatio(slidesOf[b][0])) {
        stageVar('--cm-stage-ratio', '');
        setOrient(0);
      }
      player.hidden = false;
      player.setAttribute('aria-hidden', 'false');
      lockScroll();
      isOpen = true;
      syncViewport();
      /* Le contenu et le ratio AVANT la première peinture : si le survol a
         déjà chargé les métadonnées, le cadre s'ouvre directement au bon format. */
      goTo(b, 0, true);
      /* Un cadre pour que la classe d'ouverture produise bien une transition. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (isOpen) player.classList.add('is-open');
        });
      });
      /* Le retour ne doit ramener sur la fiche que depuis le lecteur mobile :
         sur desktop, le retour du navigateur garde son sens habituel. */
      if (mobileOpen) pushHistory();
      hideThemeTab(true);
      startCta();
      /* ★ 22/10 (17h41) : indice de départ du défilement (téléphone). */
      schedulePeek();
      /* Déjà couché : pas d'invitation à tourner le téléphone. */
      if (mobileOpen && kind === 'video' && mode === 'film' && !isLand()) maybeRotateHint();
      /* Le focus va à la carte du lecteur, pas à la croix : l'espace y met en
         pause au lieu de fermer. Tab mène ensuite aux boutons. */
      if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');
      box.focus({ preventScroll: true });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      current = null;
      pos = { bubble: -1, slide: -1 };
      press = null;
      held = false;
      player.removeAttribute('data-held');
      window.clearTimeout(holdTimer);
      scrub = null;
      player.removeAttribute('data-scrub');
      if (seekRaf) window.cancelAnimationFrame(seekRaf);
      seekRaf = 0;
      seekTo = -1;
      stopProgress();
      progRead = -1;
      stopImage();
      stopCta();
      /* ★ 23h21 : plus d'animation de changement de bulle ni de mesure en
         attente. */
      stopSwap();
      window.clearTimeout(chromeTimer);
      /* ★ 22/10 (17h41) : défilement vertical, indice, chevron. La carte part
         de là où le doigt l'a laissée (première bulle glissée vers le bas). */
      swipe = null;
      boxPress = null;
      settling = false;
      window.clearTimeout(settleTimer);
      endPeek();
      window.clearTimeout(upnextTimer);
      player.removeAttribute('data-upnext');
      player.removeAttribute('data-swipe');
      [swipeNext, swipePrev].forEach(function (el) {
        if (!el) return;
        el.hidden = true;
        el.style.transform = '';
      });
      player.classList.remove('is-open', 'is-dragging', 'is-settling');
      box.style.transform = '';
      clearRotateHint();
      window.clearTimeout(hideTimer);
      player.dataset.ctrl = 'off';
      video.pause();
      video.removeAttribute('src');
      video.load();
      unlockScroll();
      hideThemeTab(false);
      if (fsElement()) exitFull();
      /* Si l'état empilé est encore le nôtre, on le dépile. Quand la fermeture
         VIENT du retour, `pushed` est déjà faux : aucun appel. */
      popHistory();

      /* Le panneau ne disparaît de l'arbre qu'une fois la sortie terminée. Le
         jeton évite qu'une réouverture rapide se fasse masquer par la sortie
         de la fermeture précédente. */
      closeToken += 1;
      var token = closeToken;
      window.setTimeout(function () {
        if (token !== closeToken || isOpen) return;
        player.hidden = true;
        player.setAttribute('aria-hidden', 'true');
      }, EXIT_MS + 40);

      if (opener) {
        opener.focus({ preventScroll: true });
        opener = null;
      }
    }

    /* ── L'onglet flottant du thème, et tout ce qui flotte avec lui ──────────
       ★ VAGUE 11 C3, point 2 · LE LECTEUR S'HABILLE PAREIL SUR LES DEUX PAGES.

       LE DÉFAUT, décrit par Raph le 27/08 : le lecteur cinéma ouvert depuis la
       carte du bandeau de collection (« Voir le film », savoir-faire artisanal)
       ne se comportait pas comme celui des fiches produit. La bulle « M » du
       chat maison continuait de flotter par-dessus le voile.

       LA CAUSE, mesurée : la profondeur du chat était corrigée dans
       `casemira-pdp-layout.css`, sous un sélecteur `body.product-template`. Les
       trois éléments qui se peignent vraiment (`.lanceur`, `.invit`, `.apercu`)
       sont posés par le widget en `position: fixed` avec `z-index: 9988`, en
       style EN LIGNE. Sur une fiche, la règle les redescendait au palier
       `--z-sticky` (100), donc sous le voile du lecteur (`--z-modal`, 400). Sur
       une collection, le sélecteur ne mordait pas : 9988 restait, et 9988 passe
       devant tout.

       LA CORRECTION EST UNE CLASSE SUR `<html>`, `csm-video-open`, posée par ce
       fichier-ci et lue par sa propre feuille de style. Deux raisons de la
       mettre là plutôt que d'étendre le sélecteur de la fiche : c'est le lecteur
       qui sait quand il est ouvert, et n'importe quelle page qui l'inclut en
       hérite - collection, fiche, et celles qui viendront - sans qu'on ait à
       recenser les gabarits. Le verrou de défilement (`csm-video-locked`) suit
       déjà exactement ce chemin.

       La FENÊTRE du chat (`.panneau`) n'est pas touchée, ici comme sur la
       fiche : une conversation ouverte reste au-dessus de tout. */
    function hideThemeTab(hide) {
      var tab = document.querySelector('.thTabBtn');
      if (tab) tab.style.display = hide ? 'none' : '';
      document.documentElement.classList.toggle('csm-video-open', !!hide);
    }

    /* ======================================================================
       7 · Écoutes
       ====================================================================== */
    bubbles.forEach(function (card, b) {
      card.addEventListener('click', function () {
        open(card);
      });
      /* Survol : on charge les métadonnées de la première vidéo, si rien ne
         joue. Une bulle qui commence par une image n'a rien à précharger ici. */
      card.addEventListener('pointerenter', function (e) {
        /* `player.hidden` et pas seulement `isOpen` : quand le lecteur se ferme,
           le curseur se retrouve au-dessus de la carte et le navigateur renvoie
           un `pointerenter`, ce qui rechargeait la source qu'on venait de vider.
           Le panneau reste `hidden = false` le temps du fondu : on laisse le
           geste de fermeture aller a son terme. */
        if (e.pointerType !== 'mouse' || isOpen || !player.hidden || !video.paused) return;
        var first = slidesOf[b][0];
        if (first.type !== 'video') return;
        if (video.getAttribute('src') === first.src) return;
        video.preload = 'metadata';
        video.setAttribute('src', first.src);
      });
    });

    [].slice.call(player.querySelectorAll('[data-csm-video-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* Libellés traduits posés par le Liquid sur le lecteur : les flèches les
       reprennent (même clé que leur aria-label de rendu, source unique). */
    if (prevBtn && label('prev')) prevBtn.setAttribute('aria-label', label('prev'));
    if (nextBtn && label('next')) nextBtn.setAttribute('aria-label', label('next'));

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (pos.bubble > 0) goTo(prevIndex(pos.bubble), 0);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var n = nextIndex(pos.bubble, bubbles.length);
        if (n >= 0) goTo(n, 0);
      });
    }

    /* ---- ★ VAGUE 4 · 5 bis · SORTIE FACILE : un clic à côté ferme ---------
       Le voile portait bien `data-csm-video-close`, mais il ne recevait aucun
       clic : `.csm-video-player__frame`, déclaré après lui et posé lui aussi en
       `inset: 0`, le recouvre entièrement. Cliquer dans la zone sombre ne
       fermait donc rien, ni sur desktop ni sur mobile, et l'utilisateur se
       retrouvait enfermé dès qu'il ne trouvait pas la croix.

       ★ BULLES STORY : la carte entière (`__box`) est désormais la story, avec
       ses segments, son en-tête, son texte et son bouton d'achat : un clic
       DEDANS ne ferme plus. Ferment : le voile, les marges autour de la carte
       et la croix. Les boutons (flèches, aperçus) gardent leur propre sens. */
    player.addEventListener('click', function (e) {
      if (!isOpen) return;
      /* Un glissement se termine aussi par un `click` : avalé en capture
         (`swallowUntil`, armé au relâché de tout défilement). */
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.csm-video-player__box')) return;
      if (t.closest('button')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goNext();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goPrev();
      } else if (e.key === ' ' || e.key === 'Spacebar') {
        /* Sur un bouton focalisé (son, plein écran, achat), l'espace garde son
           sens natif ; partout ailleurs, pause / lecture. */
        var t = e.target;
        if (t && t.closest && t.closest('button') && t !== box) return;
        e.preventDefault();
        togglePlayback();
        if (kind === 'video') setCtrl(true);
      }
    });

    /* ---- Glissement vers le bas (mécanique de la vague 1) --------------------
       ★ 22/10 (17h41) : repris par le défilement vertical (section 4, « La
       carte ») : vers le bas = bulle précédente, fermeture sur la première,
       depuis la scène comme depuis l'en-tête, le corps ou la poignée. */

    /* ---- Report outdoor : la section « Savoir-faire » redondante ------------
       L'ancien bloc `custom_liquid_dHaidd` masquait la section de contenu
       « Savoir-faire » dès qu'une vidéo zoom existait, la carte la remplaçant.
       Comportement conservé, et seulement pour ce gabarit (attribut posé par
       le snippet). À remplacer par un retrait propre de la section dans le
       gabarit outdoor-2 quand Raph le décidera. */
    if (wrap && wrap.dataset.hideLegacySavoirFaire === 'true') {
      var hideSavoirFaire = function () {
        [].slice.call(document.querySelectorAll('.section--custom-content')).forEach(function (s) {
          var h = s.querySelector('h2');
          if (h && h.textContent.trim().indexOf('Savoir-faire') !== -1) {
            var host = s.closest('.shopify-section');
            if (host) host.style.display = 'none';
          }
        });
      };
      hideSavoirFaire();
      window.setTimeout(hideSavoirFaire, 500);
      window.setTimeout(hideSavoirFaire, 1500);
    }
  });
})();
